<!-- компонент TicketView: просмотр объекта Ticket -->
<template>
	<div v-if="this.$store.state.is_auth" id="w5-ticket-view-block">

		<template v-if="!form_ErrorMessage">

			<!-- блок с локальным сообщением об ошибке -->
			<transition name="fadeControl">
				<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-top-10" role="alert">
					{{ localErrorMessage | ftc }}
					<span @click="localErrorMessage = ''" class="close" aria-label="close" title="close">×</span>
				</div>
			</transition>
			<!-- ===================================== -->

			<!-- ГЛАВНЫЙ БЛОК ПРОСМОТРА ТИКЕТА -->
			<div v-if="viewData && typeof viewData === 'object' && viewData['ticket']" class="w5-ticket-view-wrapper">

				<!-- метка тикета -->
				<template v-if="UserType === 'admin'">
					<div v-if="Ticket && Ticket['ticket_label']['value'] === 'loading'"
						class="pull-left margin-top-5"
						style="height: 18px">
						<img src="../../assets/img/loading-hor16.gif" />
					</div>
					<div v-else
						class="pull-left margin-top-5 w5-list-ticket-label"
						ref="ticketLabel"
						:class="ticketLabelClass"
						@click.stop="changeTicketLabel" />
				</template>

				<!-- тема тикета -->
				<span class="w5-ticket-view-subject" :class="UserType === 'admin' ? 'margin-left-6' : false">{{ Ticket['ticket_subject']['value']}}</span>
				<span class="clearfix"></span>

				<!-- таблица с данными -->
				<!-- для клиентов -->
				<table v-if="UserType === 'client'" class="w5-ticket-view-table">
					<tr>
						<td class="w5-ticket-view-table-cell-client">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_code']['title'] | ftc }}:</span>
							<span>{{ Ticket['ticket_code']['value'] }}</span>
						</td>
						<td class="w5-ticket-view-table-cell-client">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_status']['title'] | ftc }}:</span>
							<span :style="'color: ' + Ticket['ticket_status']['color']">{{ statusText | ftc | lower }}</span>
						</td>
						<td class="w5-ticket-view-table-cell-client">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_created']['title'] | ftc }}:</span>
							<span>{{ Ticket['ticket_created']['value'] | date('d.m.y H:M') }}</span>
						</td>
						<td class="w5-ticket-view-table-cell-client">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_updated']['title'] | ftc }}:</span>
							<span>{{ Ticket['ticket_updated']['value'] | date('d.m.y H:M') }}</span>
						</td>
					</tr>
				</table>
				<!-- для сотрудников -->
				<table v-else class="w5-ticket-view-table">
					<tr>
						<td class="w5-ticket-view-table-cell-admin-1">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_code']['title'] | ftc }}:</span>
						</td>
						<td class="w5-ticket-view-table-cell-admin-2">
							<span>{{ Ticket['ticket_code']['value'] }}</span>
						</td>
						<td class="w5-ticket-view-table-cell-admin-3">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_created']['title'] | ftc }}:</span>
						</td>
						<td class="w5-ticket-view-table-cell-admin-4">
							<span>{{ Ticket['ticket_created']['value'] | date('d.m.y H:M') }}</span>
						</td>
					</tr>
					<tr>
						<td class="w5-ticket-view-table-cell-admin-1">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_status']['title'] | ftc }}:</span>
						</td>
						<td class="w5-ticket-view-table-cell-admin-2">
							<span :style="'color: ' + Ticket['ticket_status']['color']">{{ statusText | ftc | lower }}</span>
						</td>
						<td class="w5-ticket-view-table-cell-admin-3">
							<span class="w5-ticket-view-table-header">{{ Ticket['ticket_updated']['title'] | ftc }}:</span>
						</td>
						<td class="w5-ticket-view-table-cell-admin-4">
							<span>{{ Ticket['ticket_updated']['value'] | date('d.m.y H:M') }}</span>
						</td>
					</tr>
					<tr>

						<td v-if="Department" class="w5-ticket-view-table-cell-admin-1">
							<span class="w5-ticket-view-table-header">{{ Department['name']['title'] | ftc }}:</span>
						</td>

						<td v-if="Department" class="w5-ticket-view-table-cell-admin-2">
							<linkComponent v-if="Department.access === true"
								:url="'/department/view/' + Department['id']['value']"
								:text="Department['name']['value']"
								class="can-select" />
							<span v-else>{{ Department['name']['value'] }}</span>
						</td>

						<td v-if="Account" class="w5-ticket-view-table-cell-admin-3">
							<span v-if="Account.type === 'account'" class="w5-ticket-view-table-header">{{ Account['name']['title'] | ftc }}:</span>
							<span v-if="Account.type === 'email' || Account.type === 'multi_info'" class="w5-ticket-view-table-header">{{ Account['title'] | ftc }}:</span>
						</td>
						<td v-else></td>

						<td v-if="Account" class="w5-ticket-view-table-cell-admin-4">
							<template v-if="Account.type === 'account'">
								<!-- глобальный фильтр по акк -->
								<font-awesome-icon v-if="!Account['filter'] || Account['filter']['value'] != Account['id']['value']"
									class="global-filter-button"
									:title="'account/filter' | ftc"
									@click="setAccountGlobalFilter(Account['id']['value'])"
									icon="filter"
								/>
								<font-awesome-layers v-if="Account['filter'] && Account['filter']['value'] == Account['id']['value']"
									class="global-filter-button global-filter-button-remove"
									:title="'main/delete ' + localeFtc('main/filter').toLowerCase() | ftc"
									@click="setAccountGlobalFilter()">
									<font-awesome-icon icon="filter" />
									<font-awesome-icon icon="times" />
								</font-awesome-layers>
								<linkComponent v-if="Account.access === true"
									:url="'/account/view/' + Account['id']['value']"
									:text="Account['name']['value']"
									class="can-select" />
								<span v-else>{{ Account['name']['value'] }}</span>
							</template>
							<template v-if="Account.type === 'email'">
								<span class="can-select" :class="{ 'w5-link': Account.access === true }" @click="toCreateTicket">
									{{ Account['value'] }}
								</span>
							</template>
							<template v-if="Account.type === 'multi_info'">
								<span class="can-select">
									{{ Account['value'] | ftc }}
								</span>
							</template>
						</td>
						<td v-else></td>
					</tr>
					<tr v-if="MultiType">

						<td class="w5-ticket-view-table-cell-admin-1">
							<span class="w5-ticket-view-table-header">{{ MultiType['title'] | ftc }}:</span>
						</td>

						<td v-if="MultiTextValue && Array.isArray(MultiTextValue)" colspan="3">
							<span>{{ MultiType['value'] | ftc }} - </span>
							<template v-for="(value, idx) in MultiTextValue">
								<template v-if="idx > 0">,&nbsp;</template>
								<span v-if="value['link'] === false || value['access'] === false" :key="'link-number-' + idx">{{ value['text'] | ftc }}</span>
								<linkComponent v-else
									:key="'link-number-' + idx"
									:url="value['link']"
									:text="value['text']"
									class="can-select" />
							</template>
						</td>
						<td v-else colspan="3">{{ MultiType['value'] | ftc }}</td>

					</tr>
				</table>

				<!-- блок кнопок операций над тикетом -->
				<div class="margin-top-20">
					<!-- кнопка назад -->
					<button v-if="Window && Window.history && Window.history.length > 1" type="button" class="w5-ticket-view-button btn btn-default pull-left" @click="backButton">{{ 'main/back' | ftc }}</button>
					<button v-else type="button" class="w5-ticket-view-button btn btn-default pull-left" @click="toTicketList">{{ 'main/to_list' | ftc }}</button>
					<!-- кнопка отложить -->
					<button v-if="canReplace && postPonseDepartmentId > 0 && (Department && Department.id && Department.id.value && Department.id.value != postPonseDepartmentId)"
						type="button" class="w5-ticket-view-button btn btn-submit-danger pull-left" @click="replaceTicketPendingConfirm" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="hourglass-half" />
						{{ 'main/postpone' | ftc }}
					</button>
					<!-- кнопка блокировать -->
					<button v-if="canBlock"
						type="button" class="w5-ticket-view-button btn btn-submit-black pull-left" @click="blockTicket" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="times-circle" class="color-red" />
						{{ 'ticket/blacklist' | ftc }}
					</button>
					<!-- кнопка удалить -->
					<button v-if="canDelete"
						type="button" class="w5-ticket-view-button btn btn-submit-black pull-left" @click="deleteTicket" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="times-circle" class="color-red" />
						{{ 'main/delete' | ftc }}
					</button>
					<!-- кнопка переноса в другой отдел -->
					<button v-if="canReplace"
						type="button" class="w5-ticket-view-button btn btn-submit pull-left" @click="replaceTicket" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="upload" />
						{{ 'department/department' | ftc }}
					</button>
					<!-- кнопка прикрепления к аккаунту -->
					<button v-if="canAttach"
						type="button" class="w5-ticket-view-button btn btn-submit pull-left" @click="attachTicket" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="download" />
						{{ 'account/account' | ftc }}
					</button>
					<!-- кнопка рассылки тикета -->
					<button v-if="canSend"
						type="button" class="w5-ticket-view-button btn btn-submit pull-left" @click="sendTicket" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="caret-square-right" />
						{{ 'ticket/sending' | ftc }}
					</button>
					<!-- кнопка объединения тикетов -->
					<button v-if="canMerge"
						type="button" class="w5-ticket-view-button btn btn-submit pull-left" @click="ticketMerge" :disabled="blockButtons === true ? 'disabled' : false" style="width: 90px">
						<font-awesome-icon icon="compress-alt" />
						{{ 'main/merge' | ftc }}
					</button>
					<!-- кнопка закрыть
					<button v-if="canClose && Ticket['ticket_status'] && Ticket['ticket_status']['value'] && Ticket['ticket_status']['value'] !== 'closed' && Ticket['ticket_status']['value'] !== 'deleted'"
						type="button" class="w5-ticket-view-button btn btn-submit pull-left" @click="closeTicket" :disabled="blockButtons === true ? 'disabled' : false">
						<font-awesome-icon icon="lock" />
						{{ 'main/close' | ftc }}
					</button>
					-->
					<!-- чистка стиля -->
					<span class="clearfix"></span>
				</div>

				<!-- форма ответа -->
				<transition name="fadeControl">
					<div v-if="canAnswer" v-show="answerFormVisibility">
						<!-- сама форма -->
						<div v-if="answerFormData && answerFormData.fields" class="w5-form ticket-answer-form" ref="answerForm">
							<!-- поле с типом сообщения выделяем отдельно -->
							<div v-if="$store.state.user_type === 'admin' && messageTypeField.list">
								<span class="font-weight-500">{{ messageTypeField.title | ftc }}: &nbsp; </span>
								<span class="widget-link can-select" @click.stop="changeTypeMessage">{{ messageTypeField.list[messageTypeField.value] | ftc | lower }}</span>
							</div>
							<!-- остальные поля -->
							<div v-for="(row, index) in answerFormData.fields"
								v-if="row"
								:key="index"
								:class="{ 'w5-form-row': isVisibleAnswerField(row) }"
								:style="row[0]._field_name === 'files' ? 'width: 80%; float: left;' : false">
								<template v-for="field in row">
									<!-- поле текста выделяем отдельно для debounce -->
									<Field v-if="field.type === 'textarea'"
										:key="field._field_name"
										:isVisibleRow="isVisibleAnswerField(row)"
										crud="ticketmessage"
										action="create"
										:Field="field"
										:removeRightPadding="true"
										v-model="field.value"
										@input="onTextInput"
										@valueChanged="answerFieldChanged(field)"
										@focus="onFocusAnswer(field)"
										@answerTemplateDialog="showTemplateDialog" />

									<Field v-else
										v-show="field._field_name !== 'type'"
										:key="field._field_name"
										:isVisibleRow="isVisibleAnswerField(row)"
										crud="ticketmessage"
										action="create"
										:Field="field"
										:removeRightPadding="field._field_name === 'files' || !needPadding"
										v-model="field.value"
										@valueChanged="answerFieldChanged(field)"
										@focus="onFocusAnswer(field)" />
								</template>
							</div>

							<!-- кнопка формы -->
							<button
								type="button"
								ref="submit_button"
								@click="submitAnswerForm"
								:disabled="blockAnswerForm === true || blockButtons === true ? 'disabled' : false"
								class="btn btn-submit btn-submit-green pull-right"
								:class="{ hidden: form_Loading }"
								style="margin-top: 10px">								
								{{ 'main/send' | ftc }}
							</button>

							<!-- чистка стиля -->
							<span class="clearfix"></span>
						</div>
					</div>
				</transition>

			</div>

			<!-- ГЛАВНЫЙ БЛОК СООБЩЕНИЙ ТИКЕТА -->
			<div v-if="messagesData && typeof messagesData === 'object' && messagesData['title']" class="w5-ticket-view-wrapper">
				<!-- заголовок -->
				<span class="clearfix"></span>
				<div class="w5-ticket-view-subject" :class="{ 'margin-top-10': !answerFormVisibility }">{{ messagesData['title'] | ftc }}</div>

				<!-- Блок быстрого поиска и фильтров -->
				<div>
					<!-- Быстрый поиск только для сотрудников -->
					<div v-if="UserType === 'admin'" class="form-inline">
						<Field
							:isVisibleRow="true"
							crud="ticket"
							action="view"
							name="fastSearch"
							ref="fastSearch"
							v-model="fastSearchValue"
							:Field="{ _field_name: 'fastSearch', type: 'text', title: 'main/all_fields_search', '_visible': true }"
							:removeRightPadding="true"
							:clearButton="true" @event_ClearButtonClicked="fastSearchEvent"
							@fastSearchInput="fastSearchEvent" />
					</div>

					<!-- блок количества найденых записей и выбора количества записей на страницу -->
					<div>
						<!-- Найдено -->
						<span class="font-size-80 font-weight-500">{{ 'main/list_total' | ftc }}: </span>
						<span class="font-size-80">{{ messagesData.totalCount ? messagesData.totalCount : 0 }}</span>
						<br class="visible-xs" />

						<!-- сортировка -->
						<span class="font-size-80 font-weight-500 w5-ticket-view-widget">{{ localeFtc('main/sort_by').replace('{what}', 'дате') }}: </span>
						<span class="font-size-80 widget-link margin-right-0 can-select" @click="msgSortChange">{{ msgSortFields[msgSort]['title'] | ftc | lower }}</span>
						<br class="visible-xs" />

						<!-- фильтрация -->
						<template v-if="UserType === 'admin'">
							<span class="font-size-80 font-weight-500 w5-ticket-view-widget">{{ 'main/filter' | ftc }}: </span>
							<span class="font-size-80 widget-link margin-right-0 can-select" @click="msgFilterChange">{{ msgFilterFields[msgFilter]['title']() | ftc | lower }}</span>
							<br class="visible-xs" />
						</template>

						<!-- Выбор -->
						<span class="widget-page-size">
							<span class="font-size-80 font-weight-500">{{ 'main/list_size' | ftc }}: </span>
							<span v-for="size in Config.pageSizes"
								@click="setPageSize(size)"
								:key="'page-size-id' + size"
								:class="{ 'w5-link': size !== messagesData.pageSize, 'font-weight-500': size === messagesData.pageSize }"
								class="font-size-80 can-select">
								&nbsp;{{ size }}&nbsp;
							</span>
						</span>
					</div>
					<!-- ========================================================================= -->

					<!-- блок со списком сообщений -->
					<div class="clearfix"></div>
					<div v-if="Ticket && messagesData && messagesData.rows && messagesData.rows.length" id="w5-ticket-message-list">
						
						<div v-for="(msg, idx) in messagesData.rows" class="ticket-message-wrapper" :class="fromWhoClass(msg)" :key="'message-row-id-' + idx">
						<div class="ticket-message-table-wrapper">

							<!-- NOTICE -->
							<table v-if="msg['message_type'] === 'notice'" class="w5-ticket-message-table" :class="'ticket-message-' + msg['message_type']">
								<tbody>
									<tr>
										<td class="ticket-message-notice-td-title font-weight-500">
											<!-- дата сообщения -->
											<span class="margin-right-10">{{ msg['message_created'] | date('d.m.y H:M') }}</span>
											<!-- сотрудник или пользователь -->
											<linkComponent v-if="UserType === 'admin' && msg['user_id']" :url="(msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id']" :text="msg['user_name']" class="who can-select" style="margin-right:0" />
											<span v-else class="who" style="margin-right:0">{{ msg['user_name'] | ftc }}</span>
											<!-- online-статус пользователя -->
											<span v-if="'user_online' in msg && msg['user_online'] === true && UserType === 'admin'" class="online-status-is-on"> &#9679;</span>
											<!-- операции над сообщением -->
											<OpersButton v-if="UserType === 'admin'" :message="msg" :status="Ticket['ticket_status']['value']" @action="buttonMessageAction" />
										</td>
									</tr>
									<tr>
										<td>
											<p class="ticket-message-content-text" v-formatTicketMessage="{ 'message': msg, 'fastSearchValue': fastSearchValue }"></p>
										</td>
									</tr>
									<tr v-if="(msg['message_time'] && UserType === 'admin') || (msg['message_mark'] || msg['can_mark'])">
										<td class="ticket-message-td-time-notice">
											<div v-if="msg['message_time'] && UserType === 'admin'" class="time pull-left"><font-awesome-icon icon="hourglass-half" /> {{ MinutesToCountWord(msg['message_time']) }}</div>
											<div v-if="msg['message_mark']" class="ticket-message-mark pull-right">
												{{ 'ticketmessage/mark' | ftc }}: 
												<span :class="'ticket-message-mark-' + (msg['message_mark'] === 'bad' ? 'bad' : 'good')">
													<font-awesome-icon :icon="'thumbs-' + (msg['message_mark'] === 'bad' ? 'down' : 'up')" />
												</span>
											</div>
										</td>
									</tr>
									<tr v-if="'attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length">
										<td class="ticket-message-td-attaches-notice"><Attach :attach="msg['attach']" type="notice" @preview="previewImage" /></td>
									</tr>
								</tbody>
							</table>

							<!-- NORMAL & EMAIL -->
							<table v-else-if="msg['message_type'] === 'normal' || msg['message_type'] === 'email'" class="w5-ticket-message-table ticket-message-normal">

								<!-- сообщение от сотрудника -->
								<tbody v-if="msg['user_type'] === 'admin'">
									<tr>
										<td :width="$store.state.windowWidth > 767 ? '80px' : '40px'" rowspan="2" align="center" class="ticket-message-img">
											<!-- аватар -->
											<img :src="APIServerUrl + msg['user_avatar_path']" />
										</td>
										<td class="ticket-message-td-title">
											<!-- статус прочтения -->
											<font-awesome-layers v-if="'message_read' in msg && msg['message_read'] === true" class="ticket-read margin-right-10">
												<font-awesome-icon icon="envelope" />
												<font-awesome-icon icon="check" />
											</font-awesome-layers>
											<font-awesome-layers v-else :ref="'unread-message-' + msg['message_id']" class="ticket-read margin-right-10">
												<font-awesome-icon icon="envelope" />
												<font-awesome-icon icon="asterisk" />
											</font-awesome-layers>
											<!-- сотрудник или пользователь -->
											<linkComponent v-if="UserType === 'admin' && msg['user_id']" :url="(msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id']" :text="msg['user_name']" class="who can-select" style="margin-right:0" />
											<span v-else class="who" style="margin-right:0">{{ msg['user_name'] | ftc }}</span>
											<!-- online-статус пользователя -->
											<span v-if="'user_online' in msg && msg['user_online'] === true && UserType === 'admin'" class="online-status-is-on"> &#9679;</span>
											<!-- операции над сообщением -->
											<OpersButton v-if="UserType === 'admin'" :message="msg" :status="Ticket['ticket_status']['value']" @action="buttonMessageAction" />
											<font-awesome-icon v-if="UserType === 'client'" class="pull-right client-oper-button" :title="'main/quote' | ftc" @click.stop="quoteMessage(msg)" icon="copy" />
											<!-- дата сообщения -->
											<span class="margin-right-6 pull-right font-weight-500">{{ msg['message_created'] | date('d.m.y H:M') }}</span>
										</td>
									</tr>
									<tr>
										<td class="ticket-message-td-message">
											<p v-if="msg['message_content_type'] === 'html'" class="ticket-message-pre pre-admin ticket-message-content-text" v-html="msg['message_content']"></p>
											<p v-else class="ticket-message-pre pre-admin ticket-message-content-text" v-formatTicketMessage="{ 'message': msg, 'fastSearchValue': fastSearchValue }"></p>
										</td>
									</tr>
									<tr v-if="(msg['message_time'] && UserType === 'admin') || msg['message_mark'] || (UserType !== 'admin' && msg['can_mark'] === true)">
										<td class="ticket-message-td-time" colspan="2">
											<div v-if="msg['message_time'] && UserType === 'admin'" class="time pull-left"><font-awesome-icon icon="hourglass-half" /> {{ MinutesToCountWord(msg['message_time']) }}</div>
											<div v-if="msg['message_mark']" class="ticket-message-mark pull-right">
												{{ 'ticketmessage/mark' | ftc }}: 
												<span :class="'ticket-message-mark-' + (msg['message_mark'] === 'bad' ? 'bad' : 'good')">
													<font-awesome-icon :icon="'thumbs-' + (msg['message_mark'] === 'bad' ? 'down' : 'up')" />
												</span>
											</div>
											<div v-else-if="UserType !== 'admin' && msg['can_mark'] === true" class="ticket-message-mark pull-right">
												<span class="hidden-xs">{{ 'ticketmessage/get_mark' | ftc }}</span>
												<span class="mark-button-bad" @click="setMark(msg, 'bad')"><font-awesome-icon icon="thumbs-down" /> &nbsp; {{ 'main/bad' | ftc }}</span>
												<span class="mark-button-good" @click="setMark(msg, 'good')"><font-awesome-icon icon="thumbs-up" /> &nbsp; {{ 'main/good' | ftc }}</span>
											</div>
										</td>
									</tr>
									<tr v-if="'attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length">
										<td class="ticket-message-td-attaches-admin" colspan="2"><Attach :attach="msg['attach']" type="admin" @preview="previewImage" /></td>
									</tr>
								</tbody>

								<!-- сообщение от клиента -->
								<tbody v-else-if="msg['user_type'] === 'user' || msg['user_type'] === 'unknown'">
									<tr>										
										<td class="ticket-message-client-td-title">
											<!-- online-статус пользователя -->
											<span v-if="'user_online' in msg && msg['user_online'] === true && UserType === 'admin'" class="online-status-is-on pull-right">&nbsp;&#9679;</span>
											<!-- сотрудник или пользователь -->
											<linkComponent v-if="UserType === 'admin' && msg['user_id']" :url="(msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id']" :text="msg['user_name']" class="who can-select" style="margin-right:0" />
											<span v-else class="who" style="margin-right:0">{{ msg['user_name'] | ftc }}</span>
											<!-- операции над сообщением -->
											<OpersButton v-if="UserType === 'admin'" :message="msg" :status="Ticket['ticket_status']['value']" :toLeft="true" @action="buttonMessageAction" />
											<font-awesome-icon v-if="UserType === 'client'" class="pull-left client-oper-button" :title="'main/quote' | ftc" @click.stop="quoteMessage(msg)" icon="copy" />
											<!-- дата сообщения -->
											<span class="pull-left font-weight-500" :style="UserType === 'admin' ? 'margin-left: 6px' : 'margin-left: 11px'">{{ msg['message_created'] | date('d.m.y H:M') }}</span>
										</td>
										<td :width="$store.state.windowWidth > 767 ? '80px' : '40px'" rowspan="3" align="center" class="ticket-message-img">
											<!-- аватар -->
											<img :src="APIServerUrl + msg['user_avatar_path']" />
										</td>
									</tr>
									<tr>
										<td class="ticket-message-client-td-message">
											<p class="ticket-message-pre pre-client ticket-message-content-text" v-formatTicketMessage="{ 'message': msg, 'fastSearchValue': fastSearchValue }"></p>
										</td>
									</tr>
									<tr v-if="msg['message_time']">
										<td class="ticket-message-td-time" colspan="2">
											<div class="time pull-right"><font-awesome-icon icon="hourglass-half" /> {{ MinutesToCountWord(msg['message_time']) }}</div>
										</td>
									</tr>
									<tr v-if="'attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length">
										<td class="ticket-message-td-attaches-client" colspan="2"><Attach :attach="msg['attach']" type="client" @preview="previewImage" /></td>
									</tr>
								</tbody>

							</table>
						
						</div>
						</div>

						<!-- блок пагинации -->
						<div v-if="Ticket && paginationPages.length > 0">
							<paginator :baseUrl="'/ticket/view/' + ticketId" :pages="paginationPages" :curPage="page" :lastPage="lastPage" />
						</div>
						<!-- ======================================== -->

					</div>
					<!-- ========================================================================= -->

				</div>

			</div>


			<!-- диалог удаления тикета -->
			<transition name="modal">
				<div v-show="showDeleteModal" @click="hideModalDialog('showDeleteModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'main/deleting' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showDeleteModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(deleteModalText)"></p></div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" :disabled="modalTimer && modalTimer > 0 ? 'disabled' : false" @click="deleteTicketStart">{{ modalButtonTitle }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог удаления сообщения -->
			<transition name="modal">
				<div v-show="showDeleteMessageModal" @click="hideModalDialog('showDeleteMessageModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'ticketrule/action_delete' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showDeleteMessageModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">{{ 'ticketmessage/delete_request' | ftc }}</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" @click="deleteTicketMessageStart">{{ 'ticketrule/action_delete' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>


			<!-- диалог блокировки email -->
			<transition name="modal">
				<div v-show="showEmailModal" @click="hideModalDialog('showEmailModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'ticketrule/blacklist' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showEmailModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body"><p class="padding-0-5" v-withSafeTags="localeFtc(emailModalText)"></p></div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" :disabled="modalTimer && modalTimer > 0 ? 'disabled' : false" @click="blockEmailTicketStart">{{ modalButtonTitle }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>


			<!-- диалог переноса тикета в другой отдел -->
			<transition name="modal">
				<div v-show="showReplaceModal" @click="hideModalDialog('showReplaceModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'ticketrule/action_move' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showReplaceModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										crud="ticket"
										action="view"
										name="ticketMoveModalSelectDepartment"
										ref="ticketMoveModalSelectDepartment"
										v-model="replaceValue"
										:listInModal="true"
										:listBlockToOut="1"
										:fieldInModal="true"
										:Field="replaceField"
										:removeRightPadding="true" />
								</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" @click="replaceTicketStart">{{ 'ticketrule/action_move' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог аттача тикета к аккаунту -->
			<transition name="modal">
				<div v-show="showAttachModal" @click="hideModalDialog('showAttachModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'ticket/assing_account' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showAttachModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										crud="ticket"
										action="view"
										name="ticketAttachModalSelectAccount"
										ref="ticketAttachModalSelectAccount"
										v-model="attachValue"
										:Field="attachField"										
										:removeRightPadding="true"
										:listInModal="true"
										:listBlockToOut="1"
										:fieldInModal="true"
										@focus="attachField['_errMsg'] = ''" />
								</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" :disabled="modalTimer && modalTimer > 0 ? 'disabled' : false" @click="attachTicketStart">{{ modalButtonTitle }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог запуска рассылки -->
			<transition name="modal">
				<div v-show="showSendModal" @click="hideModalDialog('showSendModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'ticket/sending_start' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showSendModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">{{ 'ticket/sending_start_confirm' | ftc }}</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" @click="sendTicketStart">{{ 'ticket/sending_start' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог просмотра картинки -->
			<div v-show="showPreviewModal" @click="hideModalDialog('showPreviewModal')" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop :style="'width:' + modalPreviewWidth + 'px;'">

						<!-- заголовок -->
						<div class="modal-header">
							<span>{{ modalPreviewText | ftc }}</span>
							<button type="button" class="close" @click="hideModalDialog('showPreviewModal')">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<img ref="previewImageInDialog" :style="modalPreviewStyle" />
							<div v-if="modalPreviewIsGallery" class="image-arrow prev" @click="galleryMove(-1)">
								<font-awesome-icon icon="arrow-left" />
							</div>
							<div v-if="modalPreviewIsGallery" class="image-arrow next" @click="galleryMove(+1)">
								<font-awesome-icon icon="arrow-right" />
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<div class="w5-preview-in-dialog-text">{{ modalPreviewTitle | ftc }}</div>
							<span style="float: left">&nbsp;({{ modalPreviewSize }})</span>
							<a class="btn btn-submit w5-file-uploader-load-button pull-right" :href="modalPreviewUrl">{{ 'main/download' | ftc }}</a>
						</div>
					</div>
				</div>
			</div>
			



			<!-- диалог выбора шаблона ответа для тикета -->
			<transition name="modal">
				<div v-show="showTemplateModal" @click="hideTemplateModal" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container ticket-template" @click="filterModalContainers">

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'text/find_templates' | ftc }}</span>
								<button type="button" class="close" @click="hideTemplateModal">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<textSearch ref="textSearchTemplateDialog" :Field="templateField" @textSelected="templateChoiced" />
							</div>
							
						</div>
					</div>
				</div>
			</transition>



			<!-- диалог объединения тикетов -->
			<transition name="modal">
				<div v-show="showMergeTicketsDialog" @click="hideModalDialog('showMergeTicketsDialog')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container" @click.stop>

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ 'ticket/merge' | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showMergeTicketsDialog')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<!-- select -->
								<div class="w5-form-row">
									<Field
										:isVisibleRow="true"
										crud="ticket"
										action="list"
										name="mergeTicketsSelectTicket"
										ref="mergeTicketsSelectTicket"
										v-model="mergeTicketsField.value"
										:listBlockToOut="1"
										:listInModal="true"
										:fieldInModal="true"
										:Field="mergeTicketsField"
										:removeRightPadding="true"
										@focus="mergeTicketsField._errMsg = ''" />
								</div>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit pull-right" @click="mergeTicketsStart">{{ 'main/continue' | ftc }}</span>
							</div>
						</div>
					</div>
				</div>
			</transition>



			<!-- блок смены метки -->
			<div ref="ticketChoiceLabelBlock" v-show="showChoiceTicketLabelBlock" class="widget-filter-ticket-label-choice" :style="ticketLabelBlockStyle">
				<div v-for="(val, idx) in ticketLabelItems"
					v-if="String(val) !== ''"
					class="w5-list-ticket-label cursor-pointer"
					:key="'label-choice-id-' + idx"
					:class="'ticket-label-color-' + String(val).toLowerCase()"
					@click="onChangeTicketLabel(val)"></div>
			</div>


			<!-- блок цитирования выделения -->
			<span id="quoteBlockWrapper" ref="quoteBlockWrapper" class="quote-selected-text-menu" @click="selectedTextToQuote">
				<span id="quoteBlock" ref="quoteBlock">{{ 'main/quote' | ftc }}</span>
			</span>

			<!-- блок предложения об отзыве -->
			<div v-if="$store.state.user_type === 'client'" class="review-block" :class="{ 'active': reviewBlockShow }">
				<span @click="reviewBlockShow = false" class="close" aria-label="close" title="close">×</span>
				<div class="review-block-link">
					<span>{{ reviewBlockText(1) }}</span>
					<a v-if="AppName === 'vdsina'" href="https://vdsina.ru/qa/q/gde-mozhno-ostavit-otzyv-o-vdsinaru" target="_blank" rel="nofollow noopener" :title="'main/review_link_title' | ftc">
						{{ reviewBlockText(2) }}
					</a>
					<a v-if="AppName === 'vdsina.com'" href="https://vdsina.com/qa/q/gde-mozhno-ostavit-otzyv-o-vdsinaru" target="_blank" rel="nofollow noopener" :title="'main/review_link_title' | ftc">
						{{ reviewBlockText(2) }}
					</a>
					<a v-else-if="AppName === 'macloud'" href="https://macloud.ru/qa/q/gde-mozhno-ostavit-otzyv-o-macloudru" target="_blank" rel="nofollow noopener" :title="'main/review_link_title' | ftc">
						{{ reviewBlockText(2) }}
					</a>
				</div>
			</div>

			<!-- общий диалог подтверждения -->
			<transition name="modal">
				<div v-show="showConfirmModal" @click="hideModalDialog('showConfirmModal')" class="modal-mask">
					<div class="modal-wrapper">
						<div class="modal-container ticket-template" @click="filterModalContainers">

							<!-- заголовок -->
							<div class="modal-header">
								<span class="font-weight-500">{{ confirmModalTitle | ftc }}</span>
								<button type="button" class="close" @click="hideModalDialog('showConfirmModal')">&times;</button>
							</div>

							<!-- тело диалога -->
							<div class="modal-body">
								<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(confirmModalContent)"></span>
							</div>

							<!-- подвал -->
							<div class="modal-footer">
								<span class="btn btn-submit btn-submit-danger pull-right" :disabled="modalTimer && modalTimer > 0 ? 'disabled' : false" @click="confirmModalFunc">{{ modalButtonTitle }}</span>
							</div>
							
						</div>
					</div>
				</div>
			</transition>

		</template>

		<errorAlert v-else :message="form_ErrorMessage" />

	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
import OpersButton from '@/components/elements/ticketmsgopers'
import paginator from '@/components/widgets/paginator'
import $ from 'jquery'
import debounce from 'debounce'
import Attach from '@/components/elements/ticketattaches'
import textSearch from '@/components/elements/text'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование компонента
	//=========================================================================
	name: 'TicketView',
	//=========================================================================
	//
	//=========================================================================
	data() {
		return {
			// ID наблюдаемого тикета
			ticketId: false,

			// локальное сообщение об ошибке
			localErrorMessage: '',

			// кешированные данные для просмотра
			viewData: null,

			// таймер который шлет каждую минуту статус просмотра
			timerView: null,
			// таймер который шлет статус "писателя"
			timerWriter: null,
			// список таймеров - установки метки о прочетнии сообщения
			timersRead: {},

			// кешированные данные по сообщениям тикета
			messagesData: null,
			// сортировка сообщений
			msgSort: 0,
			msgSortFields: [
				{ 'title': 'main/by_des', 'field': null },
				{ 'title': 'main/by_asc', 'field': 'message_id' }
			],
			// фильтрация сообщений
			msgFilter: 0,
			msgFilterFields: [
				{ 'title': () => 'main/list_all', 'field': null },
				{
					'title': () => {
						if (!this.messagesFilterData) return 'тип = заметка для сотрудников'
						return this.messagesFilterData['message_type']['title'] + ' = ' + this.messagesFilterData['message_type']['list']['notice']
					},
					'field': 'message_type',
					'value': 'notice'
				}
			],

			// номер страницы списка сообщений
			page: 1,
			// страницы в пагинаторе
			paginationPages: [],
			// последняя страница
			lastPage: 1,

			// быстрый поиск - записывается в localStorage
			fastSearchValue: '',

			// блокирует все кнопки
			blockButtons: false,

			// форма ответа
			answerFormVisibility: true, // всегда видна
			answerFormData: null,
			blockAnswerForm: false,

			// таймер для кнопок модальных диалогов
			modalTimer: false,
			modalTimerHandle: false,
			modalButtonTextCallback: null,

			// диалог удаления тикета
			showDeleteModal: false,
			deleteModalText: '',

			// даилог удаления сообщения
			showDeleteMessageModal: false,
			deleteTicketMessageId: null,

			// диалог блокировки email тикета
			showEmailModal: false,
			emailModalText: '',

			// диалог переноса тикета
			showReplaceModal: false,
			replaceValue: false,
			replaceField: {
				required: true,
				type: 'list',
				list: [],
				title: 'department/department',
				_field_name: 'ticketMoveModalDepartmentValue',
				_is_short: true,
				_visible: true,
				_errMsg: ''
			},

			// диалог аттача тикета
			showAttachModal: false,
			attachValue: false,
			attachField: {
				required: true,
				type: 'list',
				list: [],
				title: 'account/account',
				_field_name: 'ticketAttachModalAccountValue',
				_is_short: true,
				_visible: true,
				_errMsg: '',
				url: '/ticket/create?search=account&q='
			},

			// диалог запуска рассылки
			showSendModal: false,

			// выбор метки для тикета
			showChoiceTicketLabelBlock: false,
			ticketLabelBlockStyle: '',
			ticketLabelItems: {},
			ticketLabelId: null,

			// блок цитирования сообщения выделенным текстом
			$quoteBlock: null,
			oldSelectedTextOnTicketMessage: false,

			// даилог просмотра картинки
			showPreviewModal: false,
			modalPreviewWidth: 0,
			modalPreviewText: '',
			modalPreviewStyle: false,
			modalPreviewTitle: '',
			modalPreviewSize: '',
			modalPreviewUrl: '',
			modalPreviewIsGallery: null,

			// диалог выбора шаблона ответа для тикета
			showTemplateModal: false,
			templateField: {
				required: true,
				type: 'list',
				list: [],
				title: 'mails/templates',
				_field_name: 'ticketTemplateModalValue',
				_is_short: true,
				_visible: true,
				_errMsg: '',
				url: '/text/list?search=template&category=notice&q='
			},

			// объединение тикетов
			showMergeTicketsDialog: false,
			mergeTicketsField: {
				required: true,
				_field_name: 'mergeTicketsSelectTicket',
				type: 'list',
				title: 'ticket/ticket',
				_visible: true,
				_is_modal: true,
				_errMsg: '',
				url: '/ticket/update/%ID%?search=ticket&q=',
				value: null
			},

			// флаг старта выделения
			startSelection: false,

			// запрет на изменение статуса
			canChangeTicketState: true,

			// блок отзыва
			reviewBlockShow: false,

			// таймер на сброс признака печати
			timerDropPost: null,

			// общий диалог подтверждения
			showConfirmModal: false,
			confirmModalTitle: '',
			confirmModalContent: '',
			confirmModalFunc: () => {}
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// конфигурация
		//---------------------------------------------------------------------
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		//---------------------------------------------------------------------
		// тип пользователя
		//---------------------------------------------------------------------
		UserType() {
			return this.$store.state.user_type
		},
		//---------------------------------------------------------------------
		// ID пользователя
		//---------------------------------------------------------------------
		UserId() {
			return this.$store.state.user_id
		},
		//---------------------------------------------------------------------
		// ссылка на window
		//---------------------------------------------------------------------
		Window() {
			return window
		},
		//---------------------------------------------------------------------
		// текст кнопки на модальных диалогах с таймерами
		//---------------------------------------------------------------------
		modalButtonTitle() {
			if (this.modalButtonTextCallback && typeof this.modalButtonTextCallback === 'function') return this.modalButtonTextCallback()
			else return ''
		},
		//---------------------------------------------------------------------
		// все данные по текущему тикету
		//---------------------------------------------------------------------
		Ticket() {
			return this.viewData && this.viewData['ticket'] ? this.viewData['ticket'] : false
		},
		//---------------------------------------------------------------------
		// данные по аккаунту
		//---------------------------------------------------------------------
		Account() {
			// если есть Аккаунт по тикету
			if (this.viewData && this.viewData['account'] &&
				'account_name' in this.viewData['account'] && this.viewData['account']['account_name'] &&
				'account_id' in this.viewData['account'] && this.viewData['account']['account_id'] &&
				'value' in this.viewData['account']['account_name'] && 'value' in this.viewData['account']['account_id'] &&
				this.viewData['account']['account_name']['value'] && this.viewData['account']['account_id']['value'])
			{
				return {
					'type': 'account',
					'id': this.viewData['account']['account_id'],
					'name': this.viewData['account']['account_name'],
					'access': this.isAccess('account/view'),
					'filter': this.viewData['account']['global_filter']
				}
			}
			else
			{
				// если нет Аккаунта - может есть Email?
				if (this.Ticket &&
					'ticket_email' in this.Ticket && this.Ticket['ticket_email'] &&
					'value' in this.Ticket['ticket_email'] && this.Ticket['ticket_email']['value'])
				{
					return {
						'type': 'email',
						'value': this.Ticket['ticket_email']['value'],
						'title': this.Ticket['ticket_email']['title'],
						'access': this.isAccess('ticket/create')
					}
				}

				// если нет Email - может есть информация о рассылке?
				if (this.Ticket &&
					'ticket_multi_info' in this.Ticket && this.Ticket['ticket_multi_info'] &&
					'value' in this.Ticket['ticket_multi_info'] && this.Ticket['ticket_multi_info']['value'])
				{
					return {
						'type': 'multi_info',
						'title': this.Ticket['ticket_multi_info']['title'],
						'value': this.Ticket['ticket_multi_info']['value']
					}
				}
			}

			return false
		},
		//---------------------------------------------------------------------
		// данные по отделу
		//---------------------------------------------------------------------
		Department() {
			if (this.viewData && this.viewData['department'] &&
				'department_name' in this.viewData['department'] && this.viewData['department']['department_name'] &&
				'department_id' in this.viewData['department'] && this.viewData['department']['department_id'] &&
				'value' in this.viewData['department']['department_name'] && 'value' in this.viewData['department']['department_id'] &&
				this.viewData['department']['department_name']['value'] && this.viewData['department']['department_id']['value'])
			{
				return {
					'id': this.viewData['department']['department_id'],
					'name': this.viewData['department']['department_name'],
					'type': this.viewData['department']['department_type'],
					'access': this.isAccess('department/view')
				}
			}

			return false
		},
		//---------------------------------------------------------------------
		// Данные по типу рассылки тикета
		//---------------------------------------------------------------------
		MultiType() {
			if (this.Ticket &&
				'ticket_multi_type' in this.Ticket && this.Ticket['ticket_multi_type'] &&
				'value' in this.Ticket['ticket_multi_type'] && this.Ticket['ticket_multi_type']['value'])
			{
				return {
					'title': this.Ticket['ticket_multi_type']['title'],
					'value': this.Ticket['ticket_multi_type']['value']
				}
			}

			return false
		},
		//---------------------------------------------------------------------
		// Данные по самой рассылки тикета
		//---------------------------------------------------------------------
		MultiTextValue() {
			if (this.Ticket &&
				'ticket_multi_value' in this.Ticket && this.Ticket['ticket_multi_value'] &&
				'value' in this.Ticket['ticket_multi_value'] && this.Ticket['ticket_multi_value']['value'] &&
				Array.isArray(this.Ticket['ticket_multi_value']['value']))
			{
				let _val = this.Ticket['ticket_multi_value']
				let _link = 'link' in _val && String(_val['link']).length ? _val['link'] : false
				let _l = ''
				let _list = []

				_val['value'].forEach(item => {
					if (_link)
					{
						_l = _link.replace('%ID%', item['id'])
						let _crud = _link.match(/\/(\w+)\/view\/%ID%/i)
						let _access = false
						if (_crud && _crud[1]) _access = this.isAccess(_crud[1] + '/view')
						_list.push({
							'link': _l,
							'text': item['name'],
							'access': _access
						})
					}
					else
					{
						_list.push({
							'link': false,
							'text': item['name'],
							'access': false
						})
					}
				})

				return _list
			}

			return false
		},
		//---------------------------------------------------------------------
		// класс метки тикета
		//---------------------------------------------------------------------
		ticketLabelClass() {
			if (!this.viewData || !this.viewData['ticket']) return false
			// список классов
			let _class = ''
			// если можно менять метку
			if (this.viewData['ticket'] &&
				this.viewData['ticket']['ticket_status'] &&
				'value' in this.viewData['ticket']['ticket_status']/* &&
				this.viewData['ticket']['ticket_status']['value'] !== 'closed'*/)
				_class = 'cursor-pointer'

			// добавляем класс по цвету метки
			_class += ' ticket-label-color-' + String(this.viewData['ticket']['ticket_label']['value']).toLowerCase()

			return _class
		},
		//---------------------------------------------------------------------
		// статус в текстовом виде
		//---------------------------------------------------------------------
		statusText() {
			if (!this.viewData || !this.viewData['ticket'] || !this.viewData['ticket']['ticket_status'] || !this.viewData['ticket']['ticket_status']['list']) return false
			return this.viewData['ticket']['ticket_status']['list'][this.viewData['ticket']['ticket_status']['value']]
		},
		//---------------------------------------------------------------------
		// можно блокировать тикет?
		//---------------------------------------------------------------------
		canBlock() {
			/*
			let _show = false
			let _acc = false
			let _eml = false
			// получим аккаунт
			if (this.viewData && this.viewData['account'] &&
				'account_id' in this.viewData['account'] && this.viewData['account']['account_id'] && 'value' in this.viewData['account']['account_id'])
				_acc = this.viewData['account']['account_id']['value']
			// получим email
			if (this.viewData && this.viewData['ticket'] &&
				'ticket_email' in this.viewData['ticket'] && this.viewData['ticket']['ticket_email'] && 'value' in this.viewData['ticket']['ticket_email'])
				_eml = this.viewData['ticket']['ticket_email']['value']
			// блокировать можно только если нет назначеного аккаунта и есть адрес email
			if ((_acc === null || _acc === false || _acc === undefined) &&
				(_eml !== false && _eml !== null && _eml !== undefined) &&
				this.UserType === 'admin' && this.viewData['ticket']['ticket_status']['value'] !== 'deleted')
				_show = true
			// возвращаем ответ
			return _show
			*/

			if (this.UserType !== 'admin') return false

			if (this.viewData && this.viewData['ticket'] &&
				'can_blacklist' in this.viewData['ticket'] && this.viewData['ticket']['can_blacklist'] && 'value' in this.viewData['ticket']['can_blacklist'])
				return this.viewData['ticket']['can_blacklist']['value']

			return false
		},
		//---------------------------------------------------------------------
		// можно удалить тикет?
		//---------------------------------------------------------------------
		canDelete() {
			// 2022-09-21: теперь удалять могут все (при соответствующем флаге)
			// if (this.UserType !== 'admin') return false

			if (this.viewData && this.viewData['ticket'] &&
				'can_delete' in this.viewData['ticket'] &&
				'value' in this.viewData['ticket']['can_delete'] &&
				this.viewData['ticket']['can_delete']['value'] === true &&
				this.viewData['ticket']['ticket_status']['value'] !== 'deleted')
				return true

			// возвращаем ответ по умолчанию
			return false
		},
		//---------------------------------------------------------------------
		// можно закрыть тикет?
		//---------------------------------------------------------------------
		canClose() {
			if (this.viewData && this.viewData['ticket'] &&
				'can_close' in this.viewData['ticket'] &&
				'value' in this.viewData['ticket']['can_close'] &&
				this.viewData['ticket']['can_close']['value'] === false)
				return false

			// возвращаем ответ по умолчанию
			return true
		},
		//---------------------------------------------------------------------
		// можно перенести тикет?
		//---------------------------------------------------------------------
		canReplace() {
			if (this.UserType !== 'admin') return false

			if (this.viewData && this.viewData['ticket'] &&
				this.Department && this.Department.type &&
				this.Department.type.value !== 'alerts' &&
				this.viewData['ticket']['ticket_status']['value'] !== 'deleted')
				return true

			// возвращаем ответ по умолчанию
			return false
		},
		//---------------------------------------------------------------------
		// можно прикрепить тикет к аккаунту?
		//---------------------------------------------------------------------
		canAttach() {
			if (this.UserType !== 'admin') return false

			// если уже есть аккаунт - нельзя
			if (this.viewData &&
				this.viewData['account'] &&
				this.viewData['account']['account_id'] &&
				this.viewData['account']['account_id']['value'])
				return false

			if (this.viewData && this.viewData['ticket'] &&
				this.Department && this.Department.type &&
				this.Department.type.value !== 'multiuser' &&
				this.viewData['ticket']['ticket_status']['value'] !== 'closed' &&
				this.viewData['ticket']['ticket_status']['value'] !== 'deleted')
				return true

			// возвращаем ответ по умолчанию
			return false
		},
		//---------------------------------------------------------------------
		// можно разослать тикет?
		//---------------------------------------------------------------------
		canSend() {
			if (this.UserType !== 'admin') return false

			if (this.viewData && this.viewData['ticket'] &&
				this.Department && this.Department.type &&
				this.Department.type.value === 'multiuser' &&
				this.viewData['ticket']['ticket_status']['value'] !== 'closed' &&
				this.viewData['ticket']['ticket_status']['value'] !== 'deleted' &&
				this.viewData['ticket']['can_start'] &&
				this.viewData['ticket']['can_start']['value'] === true)
				return true

			// возвращаем ответ по умолчанию
			return false
		},
		//---------------------------------------------------------------------
		// можно объеденить тикет?
		//---------------------------------------------------------------------
		canMerge() {
			if (this.UserType !== 'admin') return false

			if (this.viewData && this.viewData['ticket'] &&
				'can_merge' in this.viewData['ticket'] &&
				'value' in this.viewData['ticket']['can_merge'] &&
				this.viewData['ticket']['can_merge']['value'] === true)
				return true

			// возвращаем ответ по умолчанию
			return false
		},
		//---------------------------------------------------------------------
		// можно отвечать в тикет?
		//---------------------------------------------------------------------
		canAnswer() {
			if (this.viewData && this.viewData['ticket'] &&
				this.viewData['ticket']['can_reply'] &&
				this.viewData['ticket']['can_reply']['value'] === true &&
				this.viewData['ticket']['ticket_status']['value'] !== 'deleted')
				return true

			// возвращаем ответ по умолчанию
			return false
		},
		//---------------------------------------------------------------------
		// данные по фильтру сообщений
		//---------------------------------------------------------------------
		messagesFilterData() {
			return this.messagesData && this.messagesData['filters']
				? this.messagesData['filters']
				: false
		},
		//---------------------------------------------------------------------
		// поле "Тип сообщения"
		//---------------------------------------------------------------------
		messageTypeField() {
			return this.findField('type')
		},
		//---------------------------------------------------------------------
		// нужны внутрение отстпуы в поля или нет
		//---------------------------------------------------------------------
		needPadding() {
			let _field = this.findField('hold')
			if (!_field || !_field._visible) return false
			return true
		},
		//---------------------------------------------------------------------
		// возвращает ID отдела отложенных
		//---------------------------------------------------------------------
		postPonseDepartmentId() {
			return Helper.postPonseDepartmentId()
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// дополняем jquery функцией
		$.fn.setCursorPosition = function(pos) {
			this.each(function(index, elem) {
				if (elem.setSelectionRange)
				{
					elem.setSelectionRange(pos, pos)
				}
				else if (elem.createTextRange)
				{
					var range = elem.createTextRange()
					range.collapse(true)
					range.moveEnd('character', pos)
					range.moveStart('character', pos)
					range.select()
				}
			})

			return this
		}

		// для поля ввода сообщения - нужна здержка в обработке
		this.onTextInput = debounce(this.onTextInput, 3000, true)

		// инициализация начальных данных по URL
		this.initData(this.$route.path)

		// теперь можно запросить данные
		if (this.ticketId) this.requestViewData()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)

		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
		window.addEventListener('storage', this.onLocalStorageEvent)

		// обработчики кликов мыши только по списку сообщений
		$(document).on('mousedown.quote', 'div.ticket-message-wrapper', this.startSelectionOnTicketMessages)
		$(document).on('mouseup.quote', 'div.ticket-message-wrapper', this.prepareSelectedTextToQuote)

		// закрытия кнопки цитирования
		$(document).on('keyup.quoteBlock scroll.quoteBlock mousedown.quoteBlock', this.hideQuoteBlock)

		// для клиентов вешаем обработчик на загрузку страницы, ее ресайзе и скролл
		if (this.UserType !== 'admin')
		{
			window.addEventListener('resize', this.readingMessages)
			window.addEventListener('scroll', this.readingMessages)
		}

		// закрытие вкладки или рефреш
		window.onbeforeunload = this.onBeforeUnload

		// заряжаем таймер отсылки статус просмотра тикета
		this.timerView = setInterval(() => this.sendStatus('view'), 60000)
		// и сразу тоже шлем статус
		this.sendStatus('view')

		// блок цитирования - уже должен быть создан
		this.$quoteBlock = $('span#quoteBlockWrapper')

		// обработчик для кнопок "Показать цитирование" в самом сообщении тикета
		// (когда цитирование больше 10 строк - оно скрывается)
		let _textOn = this.localeFtc('main/show_quote')
		let _textOff = this.localeFtc('main/hide_quote')
		$(document).on('click.toggle-quote-block', 'div.toggle-quote-block', function(e) {
			var _block = $(this).next().next()
			if (_block.is(':visible'))
			{
				$(this).text(_textOn)
				_block.slideUp('fast')
			}
			else
			{
				$(this).text(_textOff)
				_block.slideDown('fast')
			}
			return false
		})

		// обработчик клавиш на поле текста тикета
		$(document).on('keydown.textContent', 'textarea[name="content"]', this.handlerKeyDownContent)
	},
	//=========================================================================
	// изменился контент
	//=========================================================================
	updated() {
		// запускаем обработчик непрочитанных сообщений
		if (this.UserType !== 'admin') this.readingMessages()
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)

		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
		window.removeEventListener('storage', this.onLocalStorageEvent)

		// обработчики кликов мыши только по списку сообщений
		$(document).off('mousedown.quote')
		$(document).off('mouseup.quote')

		// закрытия кнопки цитирования
		$(document).off('keyup.quoteBlock scroll.quoteBlock mousedown.quoteBlock')

		if (this.UserType !== 'admin')
		{
			window.removeEventListener('resize', this.readingMessages)
			window.removeEventListener('scroll', this.readingMessages)
		}

		window.onbeforeunload = null

		$(document).off('click.toggle-quote-block')

		// отключаем таймеры
		this.timersOff()

		// Обнуляем статусы
		if (this.$store.state.ticketData.ticketViewId)
		{
			// обнуляем ID просматирваемого тикета
			this.$store.commit('setTicketViewId', false)
			// запросы на статусы
			if (this.canChangeTicketState)
			{
				this.sendStatus('done-post')
				this.sendStatus('done-view')
			}
		}

		// отключаем обработчик клавиш на поле текста тикета
		$(document).off('keydown.textContent')
	},
	//=========================================================================
	// обработчик: перед переходом по URL
	//=========================================================================
	beforeRouteLeave(to, from, next) {
		next(this.onBeforePopState())
	},
	//=========================================================================
	// наблюдаем переходы между тикетами внутри одного и того же компонента
	//=========================================================================
	watch: {
		'$route': function(to, from) {
			// запомним старый ID
			let _oldId = this.ticketId

			// инициируем основные данные
			this.initData(to.path)

			// если поменлся тикет
			if (_oldId && _oldId !== this.ticketId)
			{
				// обновим статусы по старому тикету
				this.sendStatus('done-post', _oldId)
				this.sendStatus('done-view', _oldId)
			}

			// теперь можно запросить данные
			if (this.ticketId) this.requestViewData()
		}
	},
	//=========================================================================
	// локальные методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация начальных данных
		//---------------------------------------------------------------------
		initData(path) {
			// обнуляем основные значения
			this.ticketId = false
			this.localErrorMessage = ''

			// обнулим быстрый поиск
			this.fastSearchValue = ''

			// закрываем все даилги
			this.closeAllModalDialogs()

			// обнулим ID тикета в котором собираются редактировать сообщение
			this.$store.commit('setTicketUpdateId', false)

			// парсим входящий URL
			let _urlParts = path
				.substr(path.charAt(0) === '/' ? 1 : 0)
				.split('/')
			// должны быть минимум три части
			if (_urlParts.length < 3 ||
				!_urlParts[0] || !_urlParts[0].length ||
				!_urlParts[1] || !_urlParts[1].length ||
				_urlParts[2] === null || _urlParts[2] === undefined || _urlParts[2] === '')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если первая часть это не "ticket"
			if (_urlParts[0] !== 'ticket')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}
			// если вторая часть это не "view"
			if (_urlParts[1] !== 'view')
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// получим ID тикета
			this.ticketId = this.$route.params['id'] && this.$route.params['id'].length ? parseInt(this.$route.params['id']) : null
			if (isNaN(this.ticketId) || this.ticketId <= 0) this.ticketId = false

			if (!this.ticketId || isNaN(this.ticketId))
			{
				this.localErrorMessage = this.localeFtc('main/unknown_page')
				return
			}

			// ID тикета известно - сохраним его и запросим статус
			this.$store.commit('setTicketViewId', this.ticketId)
			this.$store.commit('getTicketState', this.ticketId)

			// получим страницу
			this.page = this.$route.params['page'] && this.$route.params['page'].length ? parseInt(this.$route.params['page']) : 1
			if (isNaN(this.page)) this.page = 1
			// если страница отрицательная - изменим на 1
			if (this.page <= 1)
			{
				// уберем страницу
				this.page = 1
				// в любом другом случае
				this.$router.replace('/ticket/view/' + this.ticketId)
			}

			// получим параметры запроса сообщений из localStorage
			this.getMsgParamsData()
		},
		//---------------------------------------------------------------------
		// запрос данных тикета
		//---------------------------------------------------------------------
		requestViewData(isSilence) {
			// готовим URL
			let _url = '/ticket/view/' + this.ticketId

			// если не нужно показывать лоадер
			if (isSilence === true) this.$store.commit('needShowLoader', false)

			// запрашиваем еще и сообщения тикета
			this.requestMessagesData()

			// производим запрос
			this.forms_Get(_url, false,
				// успешно получили данные
				data => {
					// включаем лоадер обратно
					this.$store.commit('needShowLoader', true)

					// проверим данные
					if (!data || data['status'] !== 'ok' || data['ticket'] === undefined || data['ticket'] === null)
					{
						// ошибка - некорректные данные
						this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
					}
					else
					{
						// данные пришли - корректные
						this.viewData = Object.assign({}, this.form_GetData)

						// если вкладка отдела еще не определена
						if (this.$store.state.ticketData.currentDepartmentId === false &&
							this.viewData['department'] &&
							this.viewData['department']['department_id'] &&
							this.viewData['department']['department_id']['value'])
						{
							// установим ее
							this.$store.commit('setTicketDepartmentId', this.viewData['department']['department_id']['value'])
						}

						// теперь мы знаем - можно отвечать в этот тикет или нет
						if (this.canAnswer && !this.answerFormData)
						{
							// если можно - дополнительно запросим форму ответа, если данных по ней еще нет
							this.$http.get(this.APIServerUrl + '/ticketmessage/create/' + this.ticketId).then(
								// рассматриваем только положительный ответ
								resGet => {
									let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
									if (_dt && _dt['status'] === 'form' && _dt['fields'])
									{
										// нужно их распарсить
										this.answerFormData = this.parseFormData(_dt)
										// проставим тип сообщения
										this.changeTypeMessage()
										this.$nextTick(() => {
											// инициализация начальных значений в следующем тике
											// так как тут пока только получены данные, поля не отрендерены
											EventBus.$emit('w5-init-form-data')
										})
									}
								}
							)
						}
					}
				},
				() => this.$store.commit('needShowLoader', true)
			)
		},
		//---------------------------------------------------------------------
		// запрос сообщений по тикету
		//---------------------------------------------------------------------
		requestMessagesData(isSilence) {
			// готовим URL
			let _url = '/ticketmessage/list/' + this.page

			// каждый раз записываем в localStorage параметры запроса
			this.setMsgParamsData()

			// параметры запроса
			let _modelName = 'TicketMessageSearch'
			let _params = {
				'ticket_id': this.ticketId,
				// запрет прерывания данного запроса
				'dontAbort': true
			}
			_params[_modelName] = {}

			// быстрый поиск
			if (this.fastSearchValue !== null && this.fastSearchValue !== undefined && this.fastSearchValue !== '')
				_params[_modelName]['fast_search'] = this.fastSearchValue

			// сортировка
			if (this.msgSortFields[this.msgSort] && this.msgSortFields[this.msgSort]['field'])
				_params['sort'] = this.msgSortFields[this.msgSort]['field']

			// фильтр
			if (this.msgFilterFields[this.msgFilter] && this.msgFilterFields[this.msgFilter]['field'])
				_params[_modelName][this.msgFilterFields[this.msgFilter]['field']] = this.msgFilterFields[this.msgFilter]['value']

			// если не нужно показывать лоадер
			if (isSilence === true) this.$store.commit('needShowLoader', false)

			// производим запрос
			this.forms_Get(_url, _params,
				// успешно получили данные
				data => {
					// включаем лоадер обратно
					this.$store.commit('needShowLoader', true)

					// проверим данные
					if (!data || data['status'] !== 'ok' || data['rows'] === undefined || data['rows'] === null)
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// ошибка - некорректные данные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.form_ErrorMessage = this.localeFtc('error/api_incorrect')
					}
					else
					{
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// данные пришли - корректные
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						this.messagesData = Object.assign({}, this.form_GetData)

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// строим данные для пагинатора
						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
						// проверка на левую границу уже произведена в "initData"
						// по умолчанию - пагинатор пустой
						this.paginationPages = []
						this.lastPage = 1
						let _total = parseInt(data['totalCount'])
						let _size = parseInt(data['pageSize'])
						// если все же страницы есть
						if (_total > _size)
						{
							// получим общее количество страниц
							let _pagesCount = Math.ceil(_total / _size)
							if (!_pagesCount || isNaN(_pagesCount) || _pagesCount < 1) _pagesCount = 1

							// проверка на правую границу
							if (this.page > _pagesCount)
							{
								this.page = _pagesCount
								this.$router.replace('/ticket/view/' + this.ticketId + '/' + this.page)
							}

							// если страниц больше одной
							if (_pagesCount > 1)
							{
								this.lastPage = _pagesCount

								let _count = 0
								let _begin = this.page - 5
								if (_begin < 1) _begin = 1
								for (let k = _begin; k <= _pagesCount; k++)
								{
									_count++
									if (_count > 10) break
									this.paginationPages.push(k)
								}
							}
						}
						else
						{
							// если страниц вообще нет - уберем параметр страницы
							this.$router.replace('/ticket/view/' + this.ticketId)
						}

						//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
					}
				},
				() => this.$store.commit('needShowLoader', true)
			)
		},
		//---------------------------------------------------------------------
		// изменение сортировки сообщений
		//---------------------------------------------------------------------
		msgSortChange() {
			this.msgSort++
			if (!this.msgSortFields[this.msgSort]) this.msgSort = 0
			this.requestMessagesData()
		},
		//---------------------------------------------------------------------
		// изменение фильтрации сообщений
		//---------------------------------------------------------------------
		msgFilterChange() {
			this.msgFilter++
			if (!this.msgFilterFields[this.msgFilter]) this.msgFilter = 0
			this.requestMessagesData()
		},
		//---------------------------------------------------------------------
		// закрытие модальных диалогов
		//---------------------------------------------------------------------
		hideModalDialog(showModal) {
			this.clearModalTimer()
			EventBus.$emit('w5-body-scroll-enable')
			this.$set(this, showModal, false)
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// закрытие всех модальных диалогов
		//---------------------------------------------------------------------
		closeAllModalDialogs() {
			this.hideModalDialog('showDeleteModal')
			this.hideModalDialog('showEmailModal')
			this.hideModalDialog('showReplaceModal')
			this.hideModalDialog('showAttachModal')
			this.hideModalDialog('showSendModal')
			this.hideModalDialog('showChoiceTicketLabelBlock')
			this.hideModalDialog('showDeleteMessageModal')
			this.hideModalDialog('showPreviewModal')
			this.hideModalDialog('showMergeTicketsDialog')
			this.hideModalDialog('showConfirmModal')
			this.hideTemplateModal()
		},
		//---------------------------------------------------------------------
		// таймер для модальных диалогов
		//---------------------------------------------------------------------
		// страт таймера
		startModalTimer(seconds = 5) {
			// если таймер уже запущен - чистим его
			this.clearModalTimer()
			// установим начальное значение таймера
			this.modalTimer = seconds

			// запускаем таймер
			this.modalTimerHandle = setInterval(() => {
				this.modalTimer--
				if (this.modalTimer <= 0)
				{
					clearInterval(this.modalTimerHandle)
					this.modalTimerHandle = false
				}
			}, 1000)
		},
		// остановка и очистка таймера
		clearModalTimer() {
			if (this.modalTimerHandle)
			{
				clearInterval(this.modalTimerHandle)
				this.modalTimerHandle = false
			}
		},
		//---------------------------------------------------------------------
		// кнопка "назад"
		//---------------------------------------------------------------------
		backButton() {
			this.$router.go(-1)
		},
		//---------------------------------------------------------------------
		// кнопка "к списку"
		//---------------------------------------------------------------------
		toTicketList() {
			this.$router.push('/ticket/list')
		},
		//---------------------------------------------------------------------
		// смена метки
		//---------------------------------------------------------------------
		// вызов диалога
		changeTicketLabel() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// по умолчанию - закрываем блок выбора метки
			this.hideTicketLabelBlock()

			// доступно только сотрунику
			if (this.UserType !== 'admin') return
			// если тикет уже закрыт
			//if (this.Ticket['ticket_status']['value'] === 'closed') return
			// если нет прав
			if (!this.isAccess('ticket/update')) return

			// заполняем список меток заново
			this.ticketLabelItems = {}
			if (this.Ticket && this.Ticket['ticket_label'] && this.Ticket['ticket_label']['list'] &&
				typeof this.Ticket['ticket_label']['list'] === 'object' &&
				Object.keys(this.Ticket['ticket_label']['list']).length)
			{
				let _old = this.Ticket['ticket_label']['value'] === undefined ||
					this.Ticket['ticket_label']['value'] === null ||
					this.Ticket['ticket_label']['value'] === '' ||
					this.Ticket['ticket_label']['value'] === false ? null : this.Ticket['ticket_label']['value']
				let _list = this.Ticket['ticket_label']['list']
				for (let _val in _list) if (_list.hasOwnProperty(_val))
				{
					// форматируем новое значение
					let _new = _val === undefined || _val === null || _val === '' || _val === false ? null : _val
					// старое значение пропускаем
					if (_old === _new) continue
					// добавляем в список значения
					if (_new === null) this.ticketLabelItems[''] = null
					else this.ticketLabelItems[_new] = _new
				}
			}

			// расчитаем положение ячейки
			let _cellEl = this.$refs['ticketLabel']
			let _coord = this.getElementOffset(_cellEl)
			this.ticketLabelBlockStyle = 'top: ' + (_coord.top - 59) + 'px; left: 12px;'

			// показываем
			this.showChoiceTicketLabelBlock = true
		},
		// закрытие диалога
		hideTicketLabelBlock() {
			this.showChoiceTicketLabelBlock = false
		},
		// смена метки
		onChangeTicketLabel(value) {
			// сразу закрываем блок выбора метки
			this.hideTicketLabelBlock()

			// доступно только сотрунику
			if (this.$store.state.user_type !== 'admin') return
			// если нет прав
			if (!this.isAccess('ticket/update')) return
			// если нет ID
			if (!this.ticketId) return

			// строка найдена, можно менять - для начала ставим признак запроса
			let _oldLabel = this.viewData['ticket']['ticket_label']['value']
			this.viewData['ticket']['ticket_label']['value'] = 'loading'

			// форматируем новую метку
			let _label = value === undefined || value === null || value === '' || value === false ? '' : value

			// формируем URL
			let _url = this.APIServerUrl + '/ticket/update/' + this.ticketId + '?additional=setLabel&label=' + _label
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим новое значение
									this.viewData['ticket']['ticket_label']['value'] = _label
									// на этом все
									return
								}

								// просто возвращаем старое значение
								this.viewData['ticket']['ticket_label']['value'] = _oldLabel
							},
							// отрицательный ответ сервера
							resPost => {
								// просто возвращаем старое значение
								this.viewData['ticket']['ticket_label']['value'] = _oldLabel
							}
						)

						// на этом все
						return
					}

					// просто возвращаем старое значение
					this.viewData['ticket']['ticket_label']['value'] = _oldLabel
				},
				// отрицательный ответ
				resGet => {
					// просто возвращаем старое значение
					this.viewData['ticket']['ticket_label']['value'] = _oldLabel
				}
			)
		},
		//---------------------------------------------------------------------
		// закрытие тикета
		//---------------------------------------------------------------------
		closeTicket() {
		},
		oldcloseTicket() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// еще раз проверим статус
			if (!this.Ticket['ticket_status'] ||
				!this.Ticket['ticket_status']['value'] ||
				this.Ticket['ticket_status']['value'] === 'closed' ||
				this.Ticket['ticket_status']['value'] === 'deleted')
				return

			// блокируем все кнопки
			this.blockButtons = true

			// формируем URL для запроса
			let _url = this.APIServerUrl + '/ticket/close/' + this.ticketId
			// первый запрос - GET
			this.$http.get(_url).then(
				// success
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос по тому же URL
						this.$http.post(res.url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// success
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								// получаем ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								if (_dt && _dt['status'] === 'ok')
								{
									// переход к списку
									if (this.$store.state.user_type === 'admin' && this.$store.state.ticketData.currentDepartmentId)
										// если мы были в списке какого-то отдела
										this.$router.push('/ticket/department/' + this.$store.state.ticketData.currentDepartmentId)
									else
										// идем в общий список
										this.$router.push('/ticket/list')
									// на этом все
									return
								}

								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// fail
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				},
				// fail
				res => {
					// разблокируем кнопки
					this.blockButtons = false
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(res)
				}
			)
		},
		//---------------------------------------------------------------------
		// добавление email тикета в черный список
		//---------------------------------------------------------------------
		blockTicket() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// только сотрудник может
			if (this.UserType !== 'admin') return
			// права сотрудника
			if (!this.isAccess('ticketrule/create')) return
			// еще раз проверим
			if (!this.canBlock) return

			// формируем вопрос
			this.emailModalText = this.localeFtc('ticketrule/blacklist_prompt')
			this.emailModalText = this.emailModalText.replace('{email}', this.Ticket['ticket_email']['value'])

			// текст для кнопки
			this.modalButtonTextCallback = () => {
				if (!this.modalTimer || this.modalTimer <= 0) return this.localeFtc('main/block_action')
				return this.localeFtc('ticketrule/block_timer').replace('{count}', this.modalTimer)
			}

			// таймер
			this.startModalTimer()

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showEmailModal = true
		},
		// блокировка email тикета
		blockEmailTicketStart() {
			// проверка таймера
			if (this.modalTimer && this.modalTimer > 0) return
			// обнуление ошибки
			this.localErrorMessage = ''
			// в любом случае - закрываем диалог
			this.hideModalDialog('showEmailModal')

			// еще раз проверим
			if (!this.canBlock) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на блокировку email - формируем URL
			let _url = this.APIServerUrl + '/ticket/update?additional=setBlacklist'

			// первый запрос - GET
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)

						// ID
						let _tickets = { [_id]: 1 }
						let _post = { '_csrf': _dt['_csrf'], tickets: _tickets }

						// второй запрос - POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// смотрим ответ
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// переход к списку
									if (this.$store.state.user_type === 'admin' && this.$store.state.ticketData.currentDepartmentId)
										// если мы были в списке какого-то отдела
										this.$router.push('/ticket/department/' + this.$store.state.ticketData.currentDepartmentId)
									else
										// идем в общий список
										this.$router.push('/ticket/list')
									// на этом все
									return
								}

								// разблокируем кнопки
								this.blockButtons = false
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// удаление тикета
		//---------------------------------------------------------------------
		deleteTicket() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// только сотрудник может
			// if (this.UserType !== 'admin') return
			// права сотрудника
			if (!this.isAccess('ticket/delete')) return
			// еще раз проверим
			if (!this.canDelete) return

			// формируем вопрос
			this.deleteModalText = this.localeFtc('main/delete_msg')
			this.deleteModalText = this.deleteModalText.replace('{name}', this.localeFtc('ticket/ticket').toLowerCase() + ' ' + this.Ticket['ticket_code']['value'])

			// текст для кнопки
			this.modalButtonTextCallback = () => {
				if (!this.modalTimer || this.modalTimer <= 0) return this.localeFtc('main/delete')
				return this.localeFtc('main/delete_timer').replace('{count}', this.modalTimer)
			}

			// таймер
			this.startModalTimer()

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true
		},
		// удаление тикета
		deleteTicketStart() {
			// если еще активен таймер
			if (this.modalTimer && this.modalTimer > 0) return
			// обнуление ошибки
			this.localErrorMessage = ''
			// в любом случае - закрываем диалог
			this.hideModalDialog('showDeleteModal')

			// еще раз проверим
			if (!this.canDelete) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на удаление - формируем URL
			let _url = this.APIServerUrl + '/ticket/delete/' + _id
			// первый запрос - GET
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// переход к списку
									if (this.$store.state.user_type === 'admin' && this.$store.state.ticketData.currentDepartmentId)
										// если мы были в списке какого-то отдела
										this.$router.push('/ticket/department/' + this.$store.state.ticketData.currentDepartmentId)
									else
										// идем в общий список
										this.$router.push('/ticket/list')
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// перемещение тикета
		//---------------------------------------------------------------------
		replaceTicket() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// только сотрудник может
			if (this.UserType !== 'admin') return
			// права сотрудника
			if (!this.isAccess('ticket/update')) return
			// еще раз проверим
			if (!this.canReplace) return

			// формируем список подходящих отделов, для этого получим данные
			// отдела текущего тикета
			let _depId = this.Department ? this.Department.id.value : false
			let _depType = this.Department ? this.Department.type.value : false
			if (!_depId || !_depType) return
			// список уже должен быть сформирован
			if (!this.$store.state.ticketData.departments ||
				!Array.isArray(this.$store.state.ticketData.departments) ||
				!this.$store.state.ticketData.departments.length)
			{
				// если еще нет - запросим
				this.$store.commit('getTicketDepartments')
				return
			}

			// формируем список каждый раз
			this.replaceField['list'] = []
			this.$store.state.ticketData.departments.forEach(item => {
				// флаг
				let _flag = false
				// переносить можно только если это какой то другой отдел
				if (String(item['id']) !== String(_depId))
				{
					// если тип тот же
					if (item['type'] === _depType)
						// переносить точно можно
						_flag = true
					else
					{
						// если это отделы исключения
						if ((item['type'] === 'normal' || item['type'] === 'silent') &&
							(_depType === 'normal' || _depType === 'silent'))
							_flag = true
					}
				}
				// если в итоге можно переносить
				if (_flag)
					this.replaceField['list'].push({
						'id': item['id'],
						'name': item['name'],
						'type': item['type']
					})
			})

			// если в итоге список пуст
			if (!this.replaceField['list'].length)
			{
				this.localErrorMessage = 'ticket/no_move_departents'
				return
			}

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showReplaceModal = true
		},
		// перемещение тикета
		replaceTicketStart(gotoList = false) {
			// обнуление ошибки
			this.localErrorMessage = ''
			// в любом случае - закрываем диалог
			this.hideModalDialog('showReplaceModal')

			// еще раз проверим
			if (!this.canReplace) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// если нет ID отдела
			let _depId = this.replaceValue
			if (!_depId)
			{
				this.localErrorMessage = 'department/not_found'
				return
			}

			// определим тип выбранного отдела
			let _depType = null
			if (this.replaceField['list'] && this.replaceField['list'].length)
				this.replaceField['list'].some(dep => {
					if (String(dep.id) === String(_depId))
					{
						_depType = dep.type
						return true
					}
				})

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на перемещение - формируем URL
			let _url = this.APIServerUrl + '/ticket/update'
			// параметры
			let _params = {
				additional: 'setMove',
				department_id: _depId
			}
			// первый запрос - GET
			this.$http.get(_url, { 'params': _params }).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(resGet.url, Helper.toFormData({ '_csrf': _dt['_csrf'], tickets: { [_id]: 1 } })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['result'] && _dt['result'][_id])
								{
									// если тип отдела silent - запросим счетчики сами (пушей по ним нет)
									if (_depType === 'silent')
										this.$store.dispatch('getTicketCounters')

									// проверим - есть ли такой отдел и доступен ли он
									let _yes = this.$store.state.ticketData.departments.some(dep => {
										if (String(dep['id']) === String(_depId) && dep['access'] === true) return true
									})
									// переход к списку тикетов по данному отделу
									if (_yes)
									{
										// установим вкладку текущего отдела
										this.$store.commit('setTicketDepartmentId', _depId)
										// рефрешим тихо
										this.requestViewData(true)
										// установим активный отдел
										//this.$router.push('/ticket/department/' + _depId)
									}
									else
									{
										this.$router.push('/ticket/list')
										this.canChangeTicketState = false
									}
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// запрос подтверждения не перемещение тикета в помойку
		replaceTicketPendingConfirm() {
			// еще раз проверим
			if (!this.canReplace) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// если нет ID отдела
			let _depId = this.postPonseDepartmentId
			if (_depId < 0)
			{
				this.localErrorMessage = 'department/not_found'
				return
			}

			this.confirmDialog(
				'main/postpone',
				this.localeFtc('ticket/postpone_confirm').replace('{ticket_code}',
					this.Ticket && this.Ticket['ticket_code'] && this.Ticket['ticket_code']['value']
						? this.Ticket['ticket_code']['value']
						: ''
				),
				this.replaceTicketPending,
				'main/postpone',
				5
			)
		},
		// перемещение тикета в помойку
		replaceTicketPending() {
			// если еще активен таймер
			if (this.modalTimer && this.modalTimer > 0) return

			this.hideModalDialog('showConfirmModal')

			// обнуление ошибки
			this.localErrorMessage = ''

			// еще раз проверим
			if (!this.canReplace) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// если нет ID отдела
			let _depId = this.postPonseDepartmentId
			if (_depId < 0)
			{
				this.localErrorMessage = 'department/not_found'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на перемещение - формируем URL
			let _url = this.APIServerUrl + '/ticket/update'
			// параметры
			let _params = {
				additional: 'setMove',
				department_id: _depId
			}
			// первый запрос - GET
			this.$http.get(_url, { 'params': _params }).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(resGet.url, Helper.toFormData({ '_csrf': _dt['_csrf'], tickets: { [_id]: 1 } })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// запросим счетчики сами
									this.$store.dispatch('getTicketCounters')

									// установим вкладку текущего отдела
									this.$store.commit('setTicketDepartmentId', _depId)
									// рефрешим тихо
									this.requestViewData(true)

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// прикрепление тикета к аккаунту
		//---------------------------------------------------------------------
		attachTicket() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// только сотрудник может
			if (this.UserType !== 'admin') return
			// права сотрудника
			if (!this.isAccess('ticket/update')) return
			// еще раз проверим
			if (!this.canAttach) return

			// тип отдела текущего тикета
			let _depType = this.Department ? this.Department.type.value : false
			if (!_depType || _depType === 'multiuser') return
			// статус
			if (this.Ticket['ticket_status']['value'] === 'closed' || this.Ticket['ticket_status']['value'] === 'deleted') return

			// текст для кнопки
			this.modalButtonTextCallback = () => {
				if (!this.modalTimer || this.modalTimer <= 0) return this.localeFtc('ticket/assing_account')
				return this.localeFtc('ticket/assing_account_timer').replace('{count}', this.modalTimer)
			}

			// таймер
			this.startModalTimer()

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showAttachModal = true
		},
		// аттач тикета
		attachTicketStart(gotoList = false) {
			// если еще активен таймер
			if (this.modalTimer && this.modalTimer > 0) return
			// обнуление ошибки
			this.localErrorMessage = ''

			// если нет ID аккаунта
			let _acc = this.attachValue
			if (!_acc)
			{
				this.attachField['_errMsg'] = 'account/not_found'
				return
			}

			// в любом случае - закрываем диалог
			this.hideModalDialog('showAttachModal')

			// еще раз проверим
			if (!this.canAttach) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на перемещение - формируем URL
			let _url = this.APIServerUrl + '/ticket/update/' + _id
			// параметры
			let _params = {
				additional: 'setAssign',
				account_id: _acc
			}
			// первый запрос - GET
			this.$http.get(_url, { 'params': _params }).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(resGet.url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// тихо рефрешим таблицу
									this.requestViewData(true)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// старт рассылки тикета
		//---------------------------------------------------------------------
		sendTicket() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// только сотрудник может
			if (this.UserType !== 'admin') return
			// права сотрудника
			if (!this.isAccess('ticket/update')) return
			// еще раз проверим
			if (!this.canSend) return

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showSendModal = true
		},
		// рассылка тикета
		sendTicketStart(gotoList = false) {
			// обнуление ошибки
			this.localErrorMessage = ''
			// в любом случае - закрываем диалог
			this.hideModalDialog('showSendModal')

			// еще раз проверим
			if (!this.canSend) return

			// если нет ID объекта
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на старт рассылки - формируем URL
			let _url = this.APIServerUrl + '/ticket/update/' + _id
			// параметры
			let _params = {
				additional: 'setStart'
			}
			// первый запрос - GET
			this.$http.get(_url, { 'params': _params }).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// второй запрос - POST
						this.$http.post(resGet.url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// тихо рефрешим таблицу
									this.requestViewData(true)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// объединение тикетов
		//---------------------------------------------------------------------
		ticketMerge(row) {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return
			// только сотрудник может
			if (this.UserType !== 'admin') return
			// права сотрудника
			if (!this.isAccess('ticket/update')) return
			// еще раз проверим
			if (!this.canMerge) return

			// ставим URL поиска тикетов
			this.$set(this.mergeTicketsField, 'url', '/ticket/update/' + this.ticketId + '?search=ticket&q=')
			// и обнулим новый ID
			this.$set(this.mergeTicketsField, 'value', null)
			// обнулим ошибку
			this.$set(this.mergeTicketsField, '_errMsg', '')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showMergeTicketsDialog = true
		},

		// начало объединения тикетов
		mergeTicketsStart() {
			// обнуление ошибки
			this.localErrorMessage = ''

			// еще раз проверим
			if (!this.canMerge) return

			// проверка параметра новый ID
			if (this.mergeTicketsField.value === undefined ||
				this.mergeTicketsField.value === null ||
				String(this.mergeTicketsField.value).trim() === '')
			{
				this.mergeTicketsField._errMsg = 'ticket/not_found'
				return
			}

			// закроем диалог
			this.hideModalDialog('showMergeTicketsDialog')

			// проверка параметра старый ID
			let _id = this.ticketId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// формируем URL
			let _url = this.APIServerUrl + '/ticket/update/' + _id + '?additional=setMerge&ticket_id=' + this.mergeTicketsField.value
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// редирект на новый тикет
									this.$router.push('/ticket/view/' + this.mergeTicketsField.value)
									// на этом все
									return
								}

								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// форма ответа
		//---------------------------------------------------------------------
		// показывает форму
		showAnswerForm() {
			this.answerFormVisibility = true
		},
		// скрывает форму
		hideAnswerForm() {
			this.answerFormVisibility = false
		},
		// подтверждение формы ответа
		submitAnswerForm() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID тикета
			if (!this.ticketId) return

			// собираем все данные
			// статус тикета
			let _status = this.Ticket['ticket_status']['value']
			if (!_status) return
			// ID тикета
			let _id = this.ticketId
			if (!_id) return

			// проверим - есть ли поля с ошибками
			let _isErr = this.answerFormData.fields.some(row => {
				let _found = false
				if (row && Array.isArray(row) && row.length)
				{
					_found = row.some(fld => {
						if (!fld['_visible']) return false
						// обязательное поле?
						if (fld['required'] === true)
						{
							// если значение вообще не задано
							if (fld.value === undefined || fld.value === null)
							{
								fld['_errMsg'] = 'error/required_field'
								return true
							}
						}
					})
				}

				if (_found) return true
			})
			// ошибки есть
			if (_isErr) return

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос - формируем URL
			let _url = this.APIServerUrl + '/ticketmessage/create/' + _id
			// первый запрос - GET
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {}
						// соберем значения всех полей
						this.answerFormData.fields.forEach(row => {
							if (row && Array.isArray(row) && row.length)
							{
								row.forEach(fld => {
									let _value = fld['value']
									if (fld['type'] === 'boolean')
									{
										_value = Helper.normalizeBooleanValue(fld['value']) ? 1 : 0
									}
									_post[_dt['model']][fld['_field_name']] = _value
								})
							}
						})
						// это мы меняем
						this.$store.commit('ItIsMe', true)
						// производим запрос POST
						this.$http.post(resGet.url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет и сообщение ушло в тикет
								if (_dt && _dt['status'] === 'ok' && _dt['ticketmessage'] && typeof _dt['ticketmessage'] === 'object' && Object.keys(_dt['ticketmessage']).length)
								{
									// сообщаем что сообщение отправлено
									EventBus.$emit('w5-notificator-add', {
										'title': ' ',
										'message': 'ticketmessage/sent',
										'class': 'success',
										'type': 'nourl',
										'id': 'success-message',
										'timeout': 3000
									})

									// минимум чистим поля
									let _field = this.findField('content')
									if (_field) delete _field.value
									_field = this.findField('files')
									if (_field) delete _field.value
									EventBus.$emit('w5-set-money-field-value', {
										'type': 'integer',
										'name': 'time',
										'value': undefined
									})

									// тихо рефрешим ВСЮ страницу - так как при создании сообщения
									// у тикета может поменяться статус
									this.requestViewData(true)

									// на этом все
									return
								}

								// если ошибки нет и сообщение ушло в другой тикет
								if (_dt && _dt['status'] === 'ok' && _dt['ticket'] && typeof _dt['ticket'] === 'object' && 'ticket_id' in _dt['ticket'] && _dt['ticket']['ticket_id'])
								{
									// сообщаем что сообщение отправлено
									EventBus.$emit('w5-notificator-add', {
										'title': ' ',
										'message': 'ticketmessage/sent',
										'class': 'success',
										'type': 'nourl',
										'id': 'success-message',
										'timeout': 3000
									})

									// обнулим ID тикета что бы не слались сообщени при смене маршрута
									this.ticketId = false

									// делаем редирект на новый тикет
									this.$router.replace('/ticket/view/' + _dt['ticket']['ticket_id'])

									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// видимость строки
		isVisibleAnswerField(row) {
			// проверка данных
			if (!row || !Array.isArray(row) || !row.length) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden')
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		// фокус не поле формы
		onFocusAnswer(field) {
			if (field) field['_errMsg'] = ''
		},
		// сменилось значение поля
		answerFieldChanged(field) {
			// по умолчанию флаг обнуляется - так как могли вернуть старое значение
			this.$store.commit('changedForm', false)
			/*
			// если все таки значение поменялось
			if (Helper.isFormChanged(this.answerFormData, this.crud, this.action, this.$store))
				this.$store.commit('changedForm', this.$route.path)
			*/

			// каждый раз вычисляем условия "showif" для всех полей с таким условием
			this.showifAnswerForm()
		},
		// пользователь что-то вводил в последние 3 секунды
		onTextInput() {
			// если был уже заряжен таймер на посыл статуса о том что писать перестали
			// то нужно его обнулить
			if (this.timerWriter) clearTimeout(this.timerWriter)
			// таймер на drop тоже сразу обнуляем
			if (this.timerDropPost) clearTimeout(this.timerDropPost)

			// заряжаем таймер на посыл статуса об оконачинии писания
			this.timerWriter = setTimeout(() => {
				// если это клиент - то просто сбрасываем по истечении времени
				if (this.$store.state.user_type !== 'admin')
				{
					this.sendStatus('done-post')
					return
				}

				// у нас сотрудник
				// смотрим на поле с текстом
				let _field = this.findField('content')
				// когда текста нет - можно послать признак остановки печатанья сразу
				if (!_field.value || !_field.value.length)
				{
					this.sendStatus('done-post')
					return
				}

				// а иначе заряжаем таймер на drop, считается что пишет
				// если есть уже какой то текст - то считается что еще пишут
				this.timerDropPost = setTimeout(() => {
					this.sendStatus('done-post')
				}, 10 * 60 * 1000)
			}, 25000)

			// а пока шлем статус, что пишем в тикет
			this.sendStatus('post')
		},
		// условия showif
		showifAnswerForm() {
			// бежим по всем полям
			let _rows = this.answerFormData.fields
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf('in') !== -1)
								{
									// var in [1,2,3,4,5] => $.inArray(var, [1,2,3,4,5])
									var reg = new RegExp(/(\w+) in (\[[0-9,\s]+\])/gi)
									_expr = _expr.replace(reg, '$.inArray($1, $2) !== -1')
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		// поиск поля
		findField(name) {
			// бежим по всем полям
			let _rows = this.answerFormData.fields
			if (!_rows || !Array.isArray(_rows)) return

			// поля есть - пробежимся по ним
			let _field = null
			_rows.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// обработка клавиш на текстовом поле с содержанием тикета
		//---------------------------------------------------------------------
		handlerKeyDownContent(e) {
			if (e.keyCode === 13 && e.ctrlKey)
			{
				this.submitAnswerForm()
				e.preventDefault()
			}
		},
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов по ESC
			if (e.keyCode === 27)
			{
				this.closeAllModalDialogs()
			}

			// если показано превью картинки и это галлерея
			if (this.showPreviewModal && this.modalPreviewIsGallery)
			{
				// left
				if (e.keyCode === 37)
				{
					this.galleryMove(-1)
					e.preventDefault()
					return
				}
				// right
				if (e.keyCode === 39)
				{
					this.galleryMove(+1)
					e.preventDefault()
					return
				}
			}
		},
		//---------------------------------------------------------------------
		// обработка клика
		//---------------------------------------------------------------------
		clickHandler(e) {
			// блок для выбора метки тикета
			if (this.showChoiceTicketLabelBlock)
			{
				let _el = this.$refs['ticketChoiceLabelBlock']
				if (_el !== e.target && !_el.contains(e.target)) this.hideTicketLabelBlock()
			}
		},
		//---------------------------------------------------------------------
		// обработчик изменения поля быстрого поиска
		//---------------------------------------------------------------------
		fastSearchEvent(text) {
			this.fastSearchValue = text
			this.requestViewData()
		},
		//---------------------------------------------------------------------
		// функция устанавливает размер страницы
		//---------------------------------------------------------------------
		setPageSize(size) {
			// если это тот же размер
			if (size === this.messagesData.pageSize) return
			// если какой то левый размер
			if (this.Config.pageSizes.indexOf(size) === -1) return
			// можно делать запрос
			let _params = {
				'additional': 'setPageSize',
				'size': size
			}
			this.forms_Get('/user/index', _params,
				(data) => {
					if (!data || data['status'] !== 'ok') this.localErrorMessage = this.localeFtc('register/error')
					this.requestMessagesData(true)
				},
				() => this.requestMessagesData(true)
			)
		},
		//---------------------------------------------------------------------
		// сохранение параметров запроса в localStorage
		//---------------------------------------------------------------------
		setMsgParamsData() {
			// данные для сохранения
			let _data = {
				// быстрый поиск
				fast: this.fastSearchValue,
				// фильтр
				filter: this.msgFilter,
				// сортировка
				sort: this.msgSort
			}

			// пробуем записать
			try {
				localStorage.setItem('w5_' + this.UserId + '_ticketview', JSON.stringify(_data))
				return true
			}
			catch (err)
			{
				// ничего не делаем
				return false
			}
		},

		//---------------------------------------------------------------------
		// получение параметров запроса в localStorage
		//---------------------------------------------------------------------
		getMsgParamsData() {
			// пробуем прочитать
			try {
				if (localStorage.getItem('w5_' + this.UserId + '_ticketview'))
				{
					let _str = localStorage.getItem('w5_' + this.UserId + '_ticketview')
					let _data = JSON.parse(_str)

					// записываем полученные данные
					if ('fast' in _data) this.fastSearchValue = _data['fast']
					if ('filter' in _data) this.msgFilter = _data['filter']
					if ('sort' in _data) this.msgSort = _data['sort']

					return true
				}
				else return false
			}
			catch (err)
			{
				// ничего не делаем
				return false
			}
		},
		//---------------------------------------------------------------------
		// устанавливает оценку
		//---------------------------------------------------------------------
		setMark(msg, mark) {
			// оценку может ставить только клиент
			if (this.UserType === 'admin') return
			// проверка
			if (!msg || !mark || !msg['message_id']) return

			// нормализация оценки
			let _mark = 'good'
			if (mark !== 'good') _mark = 'bad'

			// что бы не показывал лоадер
			this.$store.commit('needShowLoader', false)

			// запрос на установку оценки
			this.$http.get(this.APIServerUrl + '/ticketmessage/update/' + msg['message_id'] + '?additional=setMark&mark=' + _mark).then(
				// данные успешно получены
				resGet => {
					// включаем обратно лоадер
					this.$store.commit('needShowLoader', true)

					// проверяем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok')
					{
						// ставим оценку в наших данных
						this.messagesData.rows.some(item => {
							if (String(item['message_id']) === String(msg['message_id']))
							{
								item['message_mark'] = _mark
								return true
							}
						})

						// если оценка положительная - предлагаем оставить отзыв
						if (_mark === 'good') this.reviewBlockShow = true
					}
				},
				() => this.$store.commit('needShowLoader', true)
			)
		},
		//---------------------------------------------------------------------
		// ставит признак прочтения сообщения
		//---------------------------------------------------------------------
		setRead(messageId) {
			// проверка
			if (!messageId) return

			// что бы не показывал лоадер
			this.$store.commit('needShowLoader', false)

			// это мы меняем
			this.$store.commit('ItIsMe', true)

			// запрос на установку метки что сообщение прочитано
			this.$http.get(this.APIServerUrl + '/ticketmessage/update/' + messageId + '?additional=setRead').then(
				// данные успешно получены
				resGet => {
					// включаем обратно лоадер
					this.$store.commit('needShowLoader', true)

					// проверяем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					if (_dt && _dt['status'] === 'ok')
					{
						// ставим признак того что сообщение прочитано
						this.messagesData.rows.some(item => {
							if (String(item['message_id']) === String(messageId))
							{
								item['message_read'] = true
								return true
							}
						})

						// на этом все
						return
					}

					// это ошибка - ставим признак того что сообщение НЕ прочитано
					this.messagesData.rows.some(item => {
						if (String(item['message_id']) === String(messageId))
						{
							item['message_read'] = false
							return true
						}
					})
				},
				// провал
				() => {
					// включаем обратно лоадер
					this.$store.commit('needShowLoader', true)
					// ставим признак того что сообщение НЕ прочитано
					this.messagesData.rows.some(item => {
						if (String(item['message_id']) === String(messageId))
						{
							item['message_read'] = false
							return true
						}
					})
				}
			)
		},
		//---------------------------------------------------------------------
		// ищет сообщение которые видны - и ставит им признак прочитанного
		//---------------------------------------------------------------------
		readingMessages(e) {
			// проверка
			if (!this.messagesData || !this.messagesData.rows || !this.messagesData.rows.length) return

			// соберем все непрочитанные сообщения
			this.messagesData.rows.forEach(item => {
				if (item['message_read'] === false)
				{
					// получим элемент в DOM
					let _el = this.$refs['unread-message-' + item['message_id']]
					if (_el && Array.isArray(_el) && _el.length) _el = _el[0]
					// если конвертик стал видим - запускаем таймер, по истечении которого
					// поставим признак прочитанности конвертика
					if (_el && this.isElementInViewport(_el))
					{
						// меняем признак
						item['message_read'] = 'send'
						// запоминаем ID
						let _id = item['message_id']
						// запускаем таймер
						if (this.timersRead[_id]) clearTimeout(this.timersRead[_id])
						this.timersRead[_id] = setTimeout(() => { this.setRead(_id) }, 1000)
					}
				}
			})
		},
		//---------------------------------------------------------------------
		// проверяет - находится ли элемент DOM в viewport
		//---------------------------------------------------------------------
		isElementInViewport(el) {
			if (!el || typeof el !== 'object' || !('getBoundingClientRect' in el)) return false
			let rect = el.getBoundingClientRect()
			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <= (window.innerWidth || document.documentElement.clientWidth)
			)
		},
		//---------------------------------------------------------------------
		// нажали на кнопку операции в сообщении
		//---------------------------------------------------------------------
		buttonMessageAction(data) {
			if (!data || !data['action'] || !data['id']) return

			if (data['action'] === 'quote')
			{
				this.quoteMessage(data['message'])
			}
			else if (data['action'] === 'view')
			{
				this.$router.push('/ticketmessage/view/' + data['id'])
			}
			else if (data['action'] === 'update')
			{
				// запоминаем ID тикета
				this.$store.commit('setTicketUpdateId', this.ticketId)
				// делаем редирект на редактирования сообщения
				this.$router.push('/ticketmessage/update/' + data['id'])
			}
			else if (data['action'] === 'delete')
			{
				this.ticketMessageDelete(data['id'])
			}
		},
		//---------------------------------------------------------------------
		// цитирование сообщения
		//---------------------------------------------------------------------
		quoteMessage(msg) {
			// проверка
			if (!msg) return
			if (!this.canAnswer) return

			// текст сообщения
			let _txt = msg['message_content']
			if (_txt === undefined || _txt === null || _txt === '') return

			// проставляем символы цитат
			_txt = this.addQuoteSymbol(_txt)

			// покажем форму ответа
			this.answerFormVisibility = true

			// найдем форму
			let _form = $(this.$refs['answerForm'])
			if (!_form || !_form.length) return
			let _textarea = _form.find('textarea:first')
			if (!_textarea || !_textarea.length) return

			// получим положение курсора
			let _cursorPosition = _textarea.prop('selectionStart')

			// вставим текст в положение курсора
			this.insertTextAtCursor(_textarea[0], '\n' + _txt)

			// обновим модель
			let _field = this.findField('content')
			if (!_field) return
			this.$set(_field, 'value', _textarea.val())
			this.answerFieldChanged(_field)

			// перейдем на форму
			this.$nextTick(() => {
				$(window).scrollTop(0)
				_textarea.setCursorPosition(_cursorPosition)
				_textarea.focus()
			})
		},
		//---------------------------------------------------------------------
		// функция - добавляет перед каждой новой строкой текста символ цитаты
		//---------------------------------------------------------------------
		addQuoteSymbol(text, symbol) {
			let _sym = symbol || '> '
			let _txt1 = text.replace(/\r/g, '')
			let _strings = _txt1.split('\n')

			for (let _i = 0; _i < _strings.length; _i++)
			{
				_strings[_i] = _sym + _strings[_i]
			}

			return _strings.join('\n')
		},
		//---------------------------------------------------------------------
		// вставка текста в элемент DOM
		//---------------------------------------------------------------------
		insertTextAtCursor(el, text, offset = 0) {
			let val = el.value
			let endIndex
			let range
			let doc = el.ownerDocument

			if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number')
			{
				endIndex = el.selectionEnd
				el.value = val.slice(0, endIndex) + text + val.slice(endIndex)
				el.selectionStart = el.selectionEnd = endIndex + text.length + offset
			}
			else if (doc.selection !== 'undefined' && doc.selection.createRange)
			{
				el.focus()
				range = doc.selection.createRange()
				range.collapse(false)
				range.text = text
				range.select()
			}
		},
		//---------------------------------------------------------------------
		// удаление сообщения
		//---------------------------------------------------------------------
		ticketMessageDelete(id) {
			// обнуление ошибки
			this.localErrorMessage = ''
			// проверяем ID сообщения
			if (!id) return

			// удалить может только сотрудник с правами
			if (this.UserType !== 'admin' || !this.isAccess('ticketmessage/delete')) return

			// запоминаем ID
			this.deleteTicketMessageId = id

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteMessageModal = true
		},
		// удаление сообщения
		deleteTicketMessageStart() {
			// обнуление ошибки
			this.localErrorMessage = ''
			// в любом случае - закрываем диалог
			this.hideModalDialog('showDeleteMessageModal')

			// если нет ID объекта
			let _id = this.deleteTicketMessageId
			if (!_id)
			{
				this.localErrorMessage = 'main/object_id'
				return
			}

			// блокируем все кнопки
			this.blockButtons = true

			// делаем запрос на удаление - формируем URL
			let _url = this.APIServerUrl + '/ticketmessage/delete/' + _id
			// первый запрос - GET
			this.$http.get(_url).then(
				// успешный ответ сервера
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// должен быть CSRF-код
					if (_dt && _dt['_csrf'])
					{
						// второй запрос - POST
						this.$http.post(_url, Helper.toFormData({ '_csrf': _dt['_csrf'] })).then(
							// успешный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false

								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// Обновляем список сообщений
									this.requestMessagesData(true)
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// разблокируем кнопки
								this.blockButtons = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)
						// на этом все
						return
					}

					// разблокируем кнопки
					this.blockButtons = false
					// ошибка получения CSRF-кода
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ сервера
				resGet => {
					// разблокируем кнопки
					this.blockButtons = false
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// определяет класс
		//---------------------------------------------------------------------
		fromWhoClass(msg) {
			if (msg['message_type'] === 'notice') return 'ticket-message-from-notice'
			if (msg['user_type'] === 'admin') return 'ticket-message-from-admin'
			if (msg['user_type'] === 'user' || msg['user_type'] === 'unknown') return 'ticket-message-from-client'
			return false
		},
		//---------------------------------------------------------------------
		// склонение чтсла минут
		//---------------------------------------------------------------------
		MinutesToCountWord: function(_count) {
			let count = parseInt(_count)

			if (count === 0 || isNaN(count)) return 'ни сколько'
			if (count >= 10 && count <= 20) return count + ' минут'

			let sCount = String(_count)
			let ch = sCount.length === 1 ? count : parseInt(sCount.substr(-1))

			if (ch === 1) return count + ' минута'

			if (ch >= 2 && ch <= 4) return count + ' минуты'

			if (ch === 0 || (ch >= 5 && ch < 10)) return count + ' минут'

			return count + ' минут'
		},
		//---------------------------------------------------------------------
		// диалог выбора шаблона ответа для тикета
		//---------------------------------------------------------------------
		// показать диалог
		showTemplateDialog() {
			// обнуляем ошибку
			this.localErrorMessage = ''
			// определим тип тикета
			let _type = 'mails'
			let _typeField = this.findField('type')
			if (_typeField && _typeField['value'] === 'notice') _type = 'notice'
			// в зависимости от типа ставим заголовок поля
			this.$set(this.templateField, 'title', _type === 'notice' ? 'notes/templates' : 'mails/templates')
			// ставим URL поиска
			this.$set(this.templateField, 'url', '/text/list?search=template&category=' + _type + '&q=')
			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showTemplateModal = true
			// фокус на поле в следующем тике
			this.$nextTick(() => {
				if (this.$refs &&
					this.$refs['textSearchTemplateDialog'] &&
					this.$refs['textSearchTemplateDialog'].$el &&
					this.$refs['textSearchTemplateDialog'].$el.querySelector('input'))
					this.$refs['textSearchTemplateDialog'].$el.querySelector('input').focus()
			})
		},
		// скрыть диалог
		hideTemplateModal() {
			// обнуляем компонент поиска текста
			EventBus.$emit('w5-click-on-modal')
			EventBus.$emit('w5-body-scroll-enable')
			this.showTemplateModal = false
			this.hideModalMask()
		},
		// выбрали шаблон
		templateChoiced(text) {
			// сразу закрываем даилог
			this.hideTemplateModal()
			// если значение так и не выбрали
			if (text === undefined || text === null || text === '') return

			// найдем форму
			let _form = $(this.$refs['answerForm'])
			if (!_form || !_form.length) return
			let _textarea = _form.find('textarea:first')
			if (!_textarea || !_textarea.length) return

			// получим положение курсора
			let _cursorPosition = _textarea.prop('selectionStart')

			// вставим текст в положение курсора
			this.insertTextAtCursor(_textarea[0], '\n' + text)

			// обновим модель
			let _field = this.findField('content')
			if (!_field) return
			this.$set(_field, 'value', _textarea.val())
			this.answerFieldChanged(_field)

			// перейдем на форму
			this.$nextTick(() => {
				_textarea.setCursorPosition(_cursorPosition)
				_textarea.focus()
			})
		},
		//---------------------------------------------------------------------
		// инициирует показ диалога с картинкой
		//---------------------------------------------------------------------
		previewImage(allData) {
			// проверка данных
			if (!allData || typeof allData !== 'object' || !allData.img) return

			// получим данные
			let data = allData.img
			let list = allData.list

			// если нет URL
			if (!data || typeof data !== 'object' || !data['attach_file']) return

			// определим - это галлерея?
			this.modalPreviewIsGallery = null
			if (list && typeof list === 'object' && Array.isArray(list) && list.length > 1)
			{
				// запоминаем текущюю картинку и весь список
				this.modalPreviewIsGallery = {
					id: data['attach_id'],
					list: list
				}
			}

			// основные данные
			this.modalPreviewUrl = this.APIServerUrl + data['attach_file']
			this.modalPreviewText = data['attach_text']
			this.modalPreviewTitle = data['attach_name']
			this.modalPreviewSize = data['attach_size']

			// обнуляем расчетные данные
			this.modalPreviewWidth = 200
			this.modalPreviewStyle = 'width: 32px; height: 32px;'
			this.$refs['previewImageInDialog'].src = '/static/img/loading32.gif'

			// пока показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showPreviewModal = true

			// грузим картинку
			this.$nextTick(() => {
				// создаем картинку
				let image = new Image()
				image.src = this.modalPreviewUrl

				// конец загрузки картинки
				image.onload = () => {
					// просто поменяем источник - браузер сам возьмет картинку из кеша
					this.$refs['previewImageInDialog'].src = image.src

					// рассчитаем сразу размеры
					let imageWidth = image.naturalWidth
					let imageHeight = image.naturalHeight
					// текущая ширина окна
					let windowWidth = this.$store.state.windowWidth
					let windowHeight = this.$store.state.windowHeight

					// максимальные размеры
					let _delta = 40

					if (windowWidth <= 420)
					{
						_delta = 20
					}
					if (windowWidth > 420 && windowWidth <= 767)
					{
						_delta = 30
					}
					if (windowWidth > 767 && windowWidth <= 900)
					{
						_delta = 40
					}
					else _delta = 60

					let maxWidth = windowWidth - _delta
					let maxHeight = windowHeight - 190
					if (maxWidth < 100) maxWidth = 100
					if (maxHeight < 100) maxHeight = 100

					// пропорционально уменьшаем
					if (imageWidth > maxWidth || imageHeight > maxHeight)
					{
						let _k = 1
						if (imageWidth > imageHeight) _k = maxWidth / imageWidth
						else _k = maxHeight / imageHeight

						imageWidth = parseInt(imageWidth * _k)
						imageHeight = parseInt(imageHeight * _k)

						// дополнительная проверка на высоту
						if (imageHeight > maxHeight)
						{
							_k = maxHeight / imageHeight
							imageWidth = parseInt(imageWidth * _k)
							imageHeight = parseInt(imageHeight * _k)
						}
					}

					this.modalPreviewWidth = imageWidth + 30
					if (this.modalPreviewWidth < 200) this.modalPreviewWidth = 200

					this.modalPreviewStyle = 'width: ' + imageWidth + 'px; height: ' + imageHeight + 'px;'
				}
			})
		},
		//---------------------------------------------------------------------
		// показ предыдущей или следующей картинки в галлерее
		//---------------------------------------------------------------------
		galleryMove(direct) {
			// если нет данных
			if (!this.modalPreviewIsGallery || typeof this.modalPreviewIsGallery !== 'object' ||
				!('id' in this.modalPreviewIsGallery) || !('list' in this.modalPreviewIsGallery))
				return
			// получим данные
			let curId = this.modalPreviewIsGallery.id
			let list = this.modalPreviewIsGallery.list

			// проверка данных
			if (curId === undefined || curId === null) return
			if (!list || typeof list !== 'object' || !Array.isArray(list) || list.length <= 1) return

			// начинаем поиск текущей картинки
			for (let idx = 0; idx < list.length; idx++)
			{
				// если нашли текущую картинку
				if (list[idx] && list[idx]['attach_id'] === curId)
				{
					// зацикливаем карусель
					if (direct < 0 && idx <= 0) idx = list.length
					if (direct > 0 && idx >= (list.length - 1)) idx = -1
					// показываем картинку
					this.previewImage({
						img: list[idx + direct],
						list
					})
					// на этом все
					return
				}
			}
		},
		//---------------------------------------------------------------------
		// возвращает координаты начала выделенной области в браузере
		//---------------------------------------------------------------------
		getSelectionCoords() {
			let sel = document.selection
			let range
			let x = 0
			let y = 0

			if (sel)
			{
				if (sel.type !== 'Control')
				{
					range = sel.createRange()
					range.collapse(true)
					x = range.boundingLeft
					y = range.boundingTop
				}
			}
			else if (window.getSelection)
			{
				sel = window.getSelection()
				if (sel.rangeCount)
				{
					range = sel.getRangeAt(0).cloneRange()
					if (range.getClientRects)
					{
						range.collapse(true)
						let rect = range.getClientRects()[0]
						x = rect.left
						y = rect.top
					}
				}
			}

			return { x: x, y: y }
		},
		//---------------------------------------------------------------------
		// событие: клик мышки по блоку с сообщением
		//---------------------------------------------------------------------
		startSelectionOnTicketMessages(e) {
			// скроем блок кнопки цитирования
			this.$quoteBlock.hide()

			// если кликнули правой кнопкой - не обращаем внимания
			if (e.which === 3) return

			// флаг - старт выделения,
			// показывает то, что именно на блоке с сообщением начали выделение
			// флаг нужен что бы, если выделяют не сообщение - игнорировать
			this.startSelection = true
		},
		//---------------------------------------------------------------------
		// событие: апнули мышку по блоку с сообщением,
		// нужно проверить на выделенный текст
		//---------------------------------------------------------------------
		prepareSelectedTextToQuote(e) {
			// если кликнули правой кнопкой - не обращаем внимания
			if (e.which === 3) return

			// если начали выделять вне списка с сообщениями - игнорируем событие
			// флаг уже итак обнулен
			if (!this.startSelection) return

			// обнуляем флаг
			this.startSelection = false

			// если отвечать запрещено - игнор
			if (!this.canAnswer) return

			// если клик был уже по самому блоку - тут ничего не делаем
			if (e.target === this.$refs['quoteBlock'] || e.target === this.$refs['quoteBlock'][0])
				return

			// получим выделенный текст
			let _selectedText = Helper.getSelectedTextDocument()

			// если ничего не выделили
			if (_selectedText === null || _selectedText === undefined || $.trim(_selectedText) === '')
			{
				// скроем блок
				this.$quoteBlock.hide()
				return
			}

			// если выделенный текст не изменился - просто скроем блок и уберем выделение
			if ($.trim(this.oldSelectedTextOnTicketMessage) === $.trim(_selectedText))
			{
				this.$quoteBlock.hide()
				Helper.removeBrowserSelectionText()
				this.oldSelectedTextOnTicketMessage = ''
				return
			}

			// блок еще скрыт или выделили новый текст
			// запомним выделенный текст, для проверки повторов
			this.oldSelectedTextOnTicketMessage = _selectedText

			// установим позицию где была поднята мышь
			this.$nextTick(() => {
				// получаем блок с сообщением, на котором апнули мышку
				let $block = $(e.currentTarget)

				// проверяем - есть ли в нем выделенный текст
				let _str = Helper.getSelectedTextWithin($block[0])
				// если нет выделенного текст - берем предыдущий блок,
				// что бы кнопка "Цитировать" показалась над блоком с выделенным текстом
				if (_str === undefined || _str === null || $.trim(_str) === '')
				{
					let $prev = $block.prev('.ticket-message-wrapper')
					if ($prev.length) $block = $prev
				}

				// получаем координаты блока с сообщением, на котором апнули мышку
				let _offset = $block.position()
				let _top = _offset.top + 5
				let _left = _offset.left

				// установим стиль и покажем блок
				this.$quoteBlock.css({ top: parseInt(_top) + 'px', left: parseInt(_left) + 'px' }).show()
			})
		},
		//---------------------------------------------------------------------
		// событие: закрытие блока цитирования
		//---------------------------------------------------------------------
		hideQuoteBlock(e) {
			// если кликнули по кнопке "Цитировать" - ничего не делаем
			if (e.target.id === 'quoteBlock') return

			// иначе закрываем кнопку
			this.$quoteBlock.hide()
		},
		//---------------------------------------------------------------------
		// событие: клик по блоку цитирования выделенного текста
		//---------------------------------------------------------------------
		selectedTextToQuote(e) {
			// закроем блок
			this.$quoteBlock.hide()

			// уберем выделение
			Helper.removeBrowserSelectionText()

			// получим выделенный текст
			let _txt = this.oldSelectedTextOnTicketMessage
			// обнулим запоминание
			this.oldSelectedTextOnTicketMessage = false
			// проверка выделенного текста
			if (_txt === undefined || _txt === null || _txt === '') return

			// если отвечать запрещено - игнор
			if (!this.canAnswer) return

			// проставляем символы цитат
			_txt = this.addQuoteSymbol(_txt)

			// покажем форму ответа
			this.answerFormVisibility = true

			// найдем форму
			let _form = $(this.$refs['answerForm'])
			if (!_form || !_form.length) return
			let _textarea = _form.find('textarea:first')
			if (!_textarea || !_textarea.length) return

			// получим положение курсора
			let _cursorPosition = _textarea.prop('selectionStart')

			// вставим текст в положение курсора
			this.insertTextAtCursor(_textarea[0], '\n' + _txt)

			// обновим модель
			let _field = this.findField('content')
			if (!_field) return
			this.$set(_field, 'value', _textarea.val())
			this.answerFieldChanged(_field)

			// перейдем на форму
			this.$nextTick(() => {
				$(window).scrollTop(0)
				_textarea.setCursorPosition(_cursorPosition)
				_textarea.focus()
			})
		},
		//---------------------------------------------------------------------
		// отслыает на АПИ сервер заданный статус
		//---------------------------------------------------------------------
		sendStatus(status = 'post', ticketId) {
			// параметр
			ticketId = ticketId || this.ticketId
			if (!ticketId) return
			if (!this.$store.state.is_auth) return

			// формируем URL
			let _url = this.APIServerUrl + '/ticket/view/' + ticketId + '?additional=setState&state=' + status

			// отключаем лоадер
			this.$store.commit('needShowLoader', false)

			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => this.$store.commit('needShowLoader', true),
							// отрицательный ответ сервера
							resPost => this.$store.commit('needShowLoader', true)
						)

						return
					}

					this.$store.commit('needShowLoader', true)
				},
				// отрицательный ответ
				resGet => this.$store.commit('needShowLoader', true)
			)
		},
		//---------------------------------------------------------------------
		// меняет тип сообщения в форме ответа
		//---------------------------------------------------------------------
		changeTypeMessage() {
			// получим поле
			let _field = this.findField('type')
			if (!_field || !_field.list) return
			// получим текущее значение
			let _value = _field.value
			// получим следующее значение
			let _nextValue = false
			let _keys = Object.keys(_field.list)
			// если значения еще нет - берем самое первое значение
			if (!_value)
			{
				_nextValue = _keys[0]
				// так же проставим начальное значение
				_field['_oldValue'] = _nextValue
			}
			// текущее значение есть - нужно следующее
			else
			{
				let _idx = _keys.indexOf(_value)
				if (_idx < 0) _idx = 0
				_idx++
				if (_idx >= _keys.length) _idx = 0
				_nextValue = _keys[_idx]
			}

			// меняем значение
			if (_nextValue) _field.value = _nextValue

			this.answerFieldChanged(_field)
		},
		//---------------------------------------------------------------------
		// установка/снятие глобального фильтра по аккаунту
		//---------------------------------------------------------------------
		setAccountGlobalFilter(account) {
			// если это не сотрудник
			if (this.$store.state.user_type !== 'admin') return

			// если это установка фильтра
			if (account)
			{
				if (!/\d+/.test(account)) return
				let _accountID = parseInt(account)
				if (isNaN(_accountID) || _accountID < 1) return

				// начинаем установку фильтра - готовим параметры и URL
				let _url = this.APIServerUrl + '/admin/index'
				let _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				}

				// обнуляем флаг в Vuex о наличии глобального фильтра
				this.$store.commit('accountGlobalFilter', false)

				// делаем сам запрос
				this.$http.get(_url, { 'params': _params }).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// стафим флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', true)

							// генерируем событие установки глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf1' + (new Date()).getTime() + '_' + _accountID)

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр установлен
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': 'main/set_filter ' + this.Account['name']['value'],
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})

							// тихо рефрешим ВСЮ страницу
							this.requestViewData(true)

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
			// если это очистка глобального фильтра
			else
			{
				// начинаем очистку фильтра - готовим URL согласно API
				let _url = this.APIServerUrl + '/admin/index?additional=removeGlobalFilter'

				// делаем сам запрос
				this.$http.get(_url).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// обнуляем флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', false)

							// генерируем событие снятия глобального фильтра
							if (window && window.localStorage)
								window.localStorage.setItem('__event', 'agf0' + (new Date()).getTime())

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							// сообщаем что глобальный фильтр удален
							EventBus.$emit('w5-notificator-add', {
								'title': ' ',
								'message': this.localeFtc('main/filter') + ' ' + this.localeFtc('main/deleted').toLowerCase(),
								'class': 'success',
								'type': 'nourl',
								'id': 'success-message',
								'timeout': 3000
							})

							// тихо рефрешим ВСЮ страницу
							this.requestViewData(true)

							// на этом все
							return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resGet)
					},
					// получили отрицательный ответ сервера
					resGet => {
						this.localErrorMessage = this.formatRequestError(resGet)
					}
				)
			}
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// обрабатываем здесь сообщения только по изменениям просматриваемого тикета
			if (_parts[0] !== 'update' || _parts[1] !== 'ticket' || String(_parts[2]) !== String(this.ticketId)) return

			// обновляем данные, пришедшие с сервера, только если не мы это сделали
			// это значение отключится по таймауту в "workBoard"
			if (!this.$store.state.ItIsMe) this.requestViewData(true)
		},
		//---------------------------------------------------------------------
		// обработчик кликов, которы если кликнули по модальному контейнеру
		// останавливает действие
		//---------------------------------------------------------------------
		toCreateTicket(e) {
			e.preventDefault()
			if (!this.Account || !this.Account.value || this.Account.access !== true) return

			// eslint-disable-next-line
			let _match = this.Account.value.match(/([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,4})+/i)
			if (_match && _match[0])
			{
				let _email = _match[0]
				if (Helper.validateEmail(_email))
				{
					this.$store.commit('createTicketEmail', {
						email: _email,
						depId: this.Department.id.value
					})
				}
				else this.$store.commit('createTicketEmail', null)
			}
			else this.$store.commit('createTicketEmail', null)

			this.$router.push('/ticket/create')
		},
		//---------------------------------------------------------------------
		// обработчик кликов, которы если кликнули по модальному контейнеру
		// останавливает действие
		//---------------------------------------------------------------------
		filterModalContainers(e) {
			if (!e || !e.target || !e.target.className) return
			if (e.target.className.indexOf('modal') > -1 || e.target.className === 'input-text')
			{
				EventBus.$emit('w5-click-on-modal')
				e.preventDefault()
				e.stopPropagation()
				e.stopImmediatePropagation()
				return
			}

			if (!e.target.parentNode || !e.target.parentNode.className) return
			if (e.target.parentNode.className.indexOf('modal') > -1 || e.target.className === 'input-text')
			{
				EventBus.$emit('w5-click-on-modal')
				e.preventDefault()
				e.stopPropagation()
				e.stopImmediatePropagation()
				return
			}
		},
		//---------------------------------------------------------------------
		// изменяют URL внутри приложения
		//---------------------------------------------------------------------
		onBeforePopState() {
			// так как на логаут два раза запрос идет - пользователь
			// может быть уже неавторизован
			if (!this.$store.state.is_auth) return true

			// если показан диалог блокировки всего приложения
			if (this.$store.state.applicationBlocked)
			{
				return false
			}

			// смотрим - есть ли измененные данные в какой то форме
			if (Helper.isFormChanged(this.answerFormData, this.crud, this.action, this.$store))
			{
				// да, есть измененные поля - нужно переспросить
				// строим сообщение вопроса по умолчанию
				let _question = 'application/leave_page_confirm'
				// если есть активные загрузки файлов
				if (this.$store.state.uploadFileCounter > 0)
					_question = this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?'
				// спрашиваем
				if (confirm(this.localeFtc(_question)))
				{
					this.timersOff()
					return true
				}
				else
				{
					// отмена действия
					return false
				}
			}

			return true
		},
		//---------------------------------------------------------------------
		// закрывают вкладку или делают рефреш
		//---------------------------------------------------------------------
		onBeforeUnload() {
			// смотрим - есть ли измененные данные в какой то форме
			// при этом, если приложение блокировано - ничего не нужно спрашивать
			if (Helper.isFormChanged(this.answerFormData, this.crud, this.action, this.$store) && !this.$store.state.applicationBlocked)
			{
				// если есть активные загрузки файлов
				if (this.$store.state.uploadFileCounter > 0)
					return this.$store.state.uploadFileCounter === 1 ? 'Идет загрузка файла, превать?' : 'Идет загрузка файлов, превать?'
				// сообщение по умолчанию
				return 'Возможно, внесенные изменения не сохранятся.'
			}
		},
		//---------------------------------------------------------------------
		// отключает все активные таймеры
		//---------------------------------------------------------------------
		timersOff() {
			// отключаем таймер модальных диалогов
			if (this.modalTimerHandle) clearInterval(this.modalTimerHandle)
			// отключаем таймер отсылки статус просмотра тикета
			if (this.timerView) clearInterval(this.timerView)
			// отключаем таймер отсылки статуса окончания писания (если он задан)
			if (this.timerWriter) clearTimeout(this.timerWriter)
			// отключаем таймер отсылки статуса окончания писания
			if (this.timerDropPost) clearTimeout(this.timerDropPost)
			// отключаем таймеры установки меток о прочтении
			for (let k in this.timersRead) if (this.timersRead.hasOwnProperty(k))
				clearTimeout(this.timersRead[k])
		},
		//---------------------------------------------------------------------
		// вырезает части для блока отзывов
		//---------------------------------------------------------------------
		reviewBlockText(part) {
			let txt = this.localeFtc('main/review_title')
			let sub = 'нравится ' + this.AppName.toLowerCase() + '?'
			let pos = txt.toLowerCase().indexOf(sub)

			if (part === 1)
			{
				if (pos > -1)
					return txt.substr(pos, sub.length)
				else
					return ''
			}

			if (part === 2)
			{
				if (pos > -1)
					return txt.substr(pos + sub.length).trim()
				else
					return ''
			}
		},
		//---------------------------------------------------------------------
		// обработчик события "storage"
		//---------------------------------------------------------------------
		onLocalStorageEvent(event) {
			// только для сотрудников
			if (this.$store.state.user_type !== 'admin') return
			// проверка события
			if (!event || event.key !== '__event' || !event.newValue) return

			if (event.newValue.indexOf('agf1') === 0 ||
				event.newValue.indexOf('agf0') === 0)
			{
				// запрос счетчиков
				this.$store.dispatch('getTicketCounters')
				this.$store.dispatch('getRequestCounter')

				// рефрешим
				this.requestViewData(true)
			}
		},
		//---------------------------------------------------------------------
		// подготовка и показ общего диалога подтверждения
		//---------------------------------------------------------------------
		confirmDialog(title, content, func, btnTitle, timerSeconds = 0) {
			// тексты диалога
			this.confirmModalTitle = title
			this.confirmModalContent = content
			this.confirmModalFunc = func

			if (timerSeconds) {
				// текст для кнопки
				this.modalButtonTextCallback = () => {
					if (!this.modalTimer || this.modalTimer <= 0) return this.localeFtc(btnTitle)
					return this.localeFtc(btnTitle) + ' - ' + this.modalTimer
				}

				// таймер
				this.startModalTimer(timerSeconds)
			}

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showConfirmModal = true
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		Field,
		OpersButton,
		paginator,
		Attach,
		textSearch
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-ticket-view-wrapper {
	padding: 15px 0;
}

.w5-ticket-view-subject {
	font-size: 20px;
	font-weight: 500;
}

.w5-ticket-view-table {
	margin-top: 15px;
}

.w5-ticket-view-table td {
	font-size: 13px;
	margin: 0;
	padding: 2px;
	border-bottom: 1px solid #ddd;
}

.w5-ticket-view-table-cell-client {
	width: 25%;
}

.w5-ticket-view-table-cell-admin-1 {
	width: 12%;
}

.w5-ticket-view-table-cell-admin-2 {
	width: 32%;
}

.w5-ticket-view-table-cell-admin-3 {
	width: 12%;
}

.w5-ticket-view-table-cell-admin-4 {
	width: 44%;
}

@media screen and (max-width: 767px) {
	.w5-ticket-view-table-cell-client {
		width: 100%;
		text-align: left;
		min-height: 30px;
	}

	.w5-ticket-view-table-cell-admin-1,
	.w5-ticket-view-table-cell-admin-2,
	.w5-ticket-view-table-cell-admin-3,
	.w5-ticket-view-table-cell-admin-4  {
		width: 100%;
		text-align: left;
		border-bottom: none !important;
		min-height: auto;
	}
}

.w5-ticket-view-table-header {
	font-weight: 500;
}

.w5-ticket-view-button {
	display: block;
	margin-bottom: 6px;
	line-height: 1 !important;
	padding: 2px !important;
	font-size: 11px !important;
	height: 24px !important;
	width: 80px;
	margin-right: 8px;
	font-weight: 300 !important;
}

.w5-ticket-view-widget {
	margin-left: 10px;
	margin-right: 0 !important;
}

@media (max-width: 767px) {
	.w5-ticket-view-widget {
		margin-left: 0;
	}
}

table.w5-ticket-message-table > tbody > tr {
	background-color: transparent !important;
}

table.w5-ticket-message-table tr {
	border-bottom: 0px;
}

table.w5-ticket-message-table td {
	padding: 0;
	margin: 0;
	font-size: 12px;
	min-height: 0;
}

/* блок для сообщения тикета */
.ticket-message-table-wrapper {
	border-radius: 4px;
}
.ticket-message-wrapper {
	position: relative;
	clear: both;
	margin: 0;
	padding: 20px 0 0 0;
}

.ticket-message-wrapper:last-of-type {
	padding-bottom: 20px;
}

/* таблица по типу сообщения */
.ticket-message-normal, .ticket-message-notice {
	width: 100%;
	font-size: 80%;    
}

/* цвета сообщений */
.ticket-message-from-client > div.ticket-message-table-wrapper {
	border: 1px solid #99ee99;
	background-color: #e9fce9;
}

.ticket-message-from-notice > div.ticket-message-table-wrapper {
	border: 1px solid #ccccee;
	background-color: #f6f6ff;
}

.ticket-message-from-other > div.ticket-message-table-wrapper {
	background-color: white;
	border: 1px solid #ddd;
}

.ticket-message-from-admin > div.ticket-message-table-wrapper {
	border: 1px solid #ddd;
	background-color: #f3f3f3;	
}

pre.pre-data {
	white-space: pre-wrap;
	white-space: -moz-pre-wrap;
	white-space: -pre-wrap;
	white-space: -o-pre-wrap;
	word-wrap: break-word;	

	word-break: break-word;
}

p.ticket-message-pre {
	word-wrap: break-word;	
	word-break: break-word;	 
	color: black;
	padding: 10px;
	border-radius: 4px !important;	
}

.pre-client {
	border: 1px solid #99ee99;
	background-color: white !important;
}
.pre-admin {
	border: 1px solid #ddd;
	background-color: white !important;
}
.pre-other {
	background-color: #f3f3f3 !important;
}

/* стилизация таблиц сообщений */
.ticket-message-normal td, .ticket-message-notice td {
	vertical-align: top;
}

.ticket-message-notice-td-title {
	padding: 10px 5px 0 10px !important;
}

.ticket-message-td-title {
	padding: 10px 5px 0 0 !important;
	height: 28px;
}

.ticket-message-client-td-title {
	padding: 10px 0 0 0 !important;
	height: 28px;
}

.ticket-message-td-title .who, .ticket-message-client-td-title .who {
	font-weight: 500;
}

.ticket-message-client-td-title .who {
	float: right;
}

.ticket-message-notice-td-title .who {
	margin-right: 20px;
}

.ticket-message-td-message {
	padding: 5px 10px 0 0 !important;
}

.ticket-message-client-td-message {
	padding: 5px 0 0 10px !important;	
}

.ticket-message-td-time {
	padding: 0 5px 10px 10px !important;
	height: 28px;	
}

.ticket-message-td-time-notice {
	padding: 0 0 0 10px !important;
	height: 28px;	
}

.ticket-message-td-time div.time, .ticket-message-td-time-notice div.time {
	font-size: 90%;
	font-weight: 500;
}

.ticket-message-notice > tbody > tr > td > p {
	padding: 5px 10px 10px 10px !important;
	margin: 0;
	color: black;
}

.ticket-message-img {
	padding: 10px !important;
}

.ticket-message-img img {
	width: 60px;
	height: 60px;

	border: 1px solid #666;
	border-radius: 30px !important;	
}

/* блок ошибок в просмотре сообщения тикета и в редактировании тикета */
.ticket-form-error-block {
	display: none;
	padding: 10px;
	margin-bottom: 10px;
	border-radius: 4px !important;	
}

/* разделители полей в форме редактирования сообщения */
.ticket-message-form-divider {
	display: none;
	float: left;
	width: 100%;
	height: 20px;
}

/* оценка сообщения */
.ticket-message-mark {
	font-weight: 400;
	margin-right: 10px;
}

/* таблица дыннх в просмотре тикета */
.data-in-ticket-view {
	width: 100%;
}

.data-in-ticket-view > tbody > tr > td {
	vertical-align: top;
	padding: 2px;
	border-bottom: 1px solid #ddd;
}

.mark-button-bad {
	font-weight: normal;
	font-size: 90%;
	padding: 2px 6px;
	margin-left: 6px;
	background: #d9534f !important;
	border: 1px solid #d43f3a !important;
	color: white;

	-webkit-border-radius: 4px !important;
	-moz-border-radius: 4px !important;
	border-radius: 4px !important;

	cursor: pointer;
}

.mark-button-bad:hover {
	background: #f9302c !important;
	border: 1px solid #f9302c !important;
	transition: background .2s !important;
	-webkit-transition: background .2s !important;	
}

.mark-button-good {
	font-weight: normal;
	font-size: 90%;
	padding: 2px 6px;
	margin-left: 6px;
	background: #53b94f !important;
	border: 1px solid #3fb43a !important;
	color: white;

	-webkit-border-radius: 4px !important;
	-moz-border-radius: 4px !important;
	border-radius: 4px !important;

	cursor: pointer;
}

.mark-button-good:hover {
	background: #30c92c !important;
	border: 1px solid #30c92c !important;
	transition: background .2s !important;
	-webkit-transition: background .2s !important;	
}

.ticket-message-mark-bad {
	font-weight: 500;
	font-size: 90%;
	padding: 1px 4px;
	margin-left: 6px;
	background: #d9534f !important;
	border: 1px solid #d43f3a !important;
	color: white;

	border-radius: 4px !important;
}
.ticket-message-mark-good {
	font-weight: 500;
	font-size: 90%;
	padding: 1px 4px;
	margin-left: 6px;
	background: #53b94f !important;
	border: 1px solid #3fb43a !important;
	color: white;

	border-radius: 4px !important;
}

span.quote-selected-text-menu {
	display: none;
	position: absolute;
	background-color: #666;
	border-radius: 4px;
	z-index: 11;
}

span.quote-selected-text-menu > span {
	color: white;
	font-size: 11px;
	font-weight: 300;
	display: inline-block;
	padding: 8px 12px;
	cursor: pointer;
}



.ticket-message-td-attaches-notice {
	padding: 0 10px 10px 10px !important;
}

.ticket-message-td-attaches-client {
	padding: 0 10px 10px 10px !important;
}

.ticket-message-td-attaches-admin {
	padding: 0 10px 10px 10px !important;
}



/* цитаты в сообщениях тикета */
span.w5-quoted-text {
	color: #36c;
	font-style: italic;
}

span.w5-quoted-text-level-1 {
	color: #69f;
	font-style: italic;	
}
span.w5-quoted-text-level-2 {
	color: #3c6;
	font-style: italic;	
}

span.w5-quoted-text-level-3 {
	color: #f99;
	font-style: italic;	
}

span.w5-quoted-text-level-4 {
	color: #6cc;
	font-style: italic;	
}

span.w5-quoted-text-level-5 {
	color: #cc6;
	font-style: italic;	
}

span.w5-quoted-text-level-6 {
	color: #ccc;
	font-style: italic;	
}

/* ссылки в сообщениях тикета */
.ticket-message-content-text > a, .ticket-message-content-text > a:hover, .ticket-message-content-text > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-1 > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-1 > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-1 > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-2 > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-2 > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-2 > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-3 > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-3 > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-3 > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-4 > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-4 > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-4 > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-5 > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-5 > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-5 > a:focus,
.ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-6 > a, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-6 > a:hover, .ticket-message-content-text > div.quote-block > span.w5-quoted-text-level-6 > a:focus
{
	text-decoration: underline;
	color: #337ab7;	
}



/* кнопка показа/скрытия цитирования */
.toggle-quote-block {	
	display: inline;
	margin-top: 5px;
	color: #69f;
	font-weight: 500;
	cursor: pointer;
}

.toggle-quote-block-hided {
	display: none;
}

/* блок со строками цитирования */
.quote-block {
	margin-top: 5px;
	line-height: 1.2;
}

.quote-block-hided {
	display: none;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	padding: 10px 0px;
	margin-top: 10px;
}

.ticket-answer-form {
	margin: 15px 0 0;
	padding: 15px 15px 5px;
	border: 1px solid #ddd;	
	border-radius: 4px;
}

.client-oper-button {
	position: relative;
	top: 2px;
	color: #999;
	margin-right: 8px;
	margin-left: 6px;
	cursor: pointer;
	transition: color 0.2s;
}

.client-oper-button.pull-left {
	margin-right: 0;
	margin-left: 12px;
}

.client-oper-button:hover {
	color: rgb(44, 138, 216);
}

.review-block {
	position: fixed;
	min-width: 300px;
	width: 50%;
	bottom: -180px;
	left: 50%;
	margin-left: -25%;
	border-radius: 4px;
	background: #53b94f;
    border: 1px solid #3fb43a;
	color: white;
	padding: 25px 15px;
	transition: bottom 0.2s;
	z-index: 10;
}
.review-block.active {
	bottom: 60%;
}
.review-block > span.close {
	position: absolute;
	top: 5px;
	right: 8px;
}
.review-block > .review-block-link {
	text-align: center;
}
.review-block > .review-block-link > span,
.review-block > .review-block-link > a {
	font-weight: 400;
	font-size: 18px;
	transition: all 0.3s;
}
.review-block > .review-block-link > a:hover {
}

/* стрелки галлереи */
.image-arrow {
	position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    z-index: 1;
    cursor: pointer;
    text-align: center;
    background-color: transparent;
}

.image-arrow > svg {
	position: relative;
	top: 50%;
	margin-top: -24px;
	font-size: 48px;
	color: #2c8ad8;
	opacity: 0;
}
.image-arrow:hover > svg {
	opacity: 1;
}

.image-arrow.prev {
	left: 0;
	border-radius: 0 4px 4px 0;	
}
.image-arrow.next {
	right: 0;
	border-radius: 4px 0 0 4px;
}



/* мобила */
@media screen and (max-width: 767px) {
	table.w5-ticket-view-table td.w5-ticket-view-table-cell-admin-1,
	table.w5-ticket-view-table td.w5-ticket-view-table-cell-admin-3 {
		min-height: auto
	}

	table.w5-ticket-message-table tr {
		border-bottom: 0 !important;
	}

	table.w5-ticket-message-table td {
		border-bottom: none !important;
		text-align: left !important;
		min-height: auto !important;
	}

	table.w5-ticket-message-table td:before {
		content: none !important;
	}

	table.w5-ticket-message-table tr:first-of-type {
		border-top: none !important;
	}

	.ticket-message-td-title {
		width: 100%;
		padding: 10px 5px 0 5px !important;
	}

	.ticket-message-client-td-title {
		width: 100%;
		padding: 10px 5px 0 0 !important;
	}

	.ticket-message-notice-td-title {
		width: 100%;
		display: inline-block !important;
	}

	.ticket-message-td-time {
		width: 100%;
		display: inline-block !important;	
	}

	.ticket-message-td-message {
		width: 100%;
		display: inline-block !important;
		padding: 5px 5px 0 5px !important;
	}

	.ticket-message-client-td-message {
		width: 100%;
		display: inline-block !important;
		padding: 5px 5px 0 5px !important;	
	}

	.ticket-message-td-attaches-client {
		width: 100%;
		display: inline-block !important;
		padding: 0px 5px 5px 5px !important;
	}

	div.ticket-read.fa-layers {
		display: none !important;
	}

	.ticket-message-img {
		display: none !important;
		padding: 5px !important;
	}

	.ticket-message-img img {
		width: 30px;
		height: 30px;
		border-radius: 15px !important;
	}

	.ticket-answer-form {
		margin: 0;
		margin-top: 15px;
		padding: 15px 5px 5px;
		border: 1px solid #ddd;	
		border-radius: 4px;
	}

	button.btn.btn-submit.btn-submit-green.pull-right {
		float: left !important;
	}

	.client-oper-button {
		margin-right: 2px;
		margin-left: 2px;
	}

	.review-block {
		width: 300px;
		left: 50%;
		margin-left: -150px;
	}
	.review-block > .review-block-link > span,
	.review-block > .review-block-link > a {
		font-size: 15px;
	}

	.ticket-message-mark {
		margin-right: 0;
	}
}

</style>



// WEBPACK FOOTER //
// TicketView.vue?148a1cd1